/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect, useContext } from 'react';

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { useParams } from 'react-router';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputSwitch } from 'primereact/inputswitch';
import { InputNumber } from 'primereact/inputnumber';
import { decodeToken } from 'react-jwt';
import { Toast } from 'primereact/toast';
import { SelectButton } from 'primereact/selectbutton';
import { FileUpload } from 'primereact/fileupload';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';

// ------------------ COMPONENTES DE BASE--------------------------
import Card from '../../../../Base/Components/Card/Card';
import { useForm } from '../../../../Base/Hooks/useForm';
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import Loader from '../../../../Base/Components/Loader/Loader';
import { toastShow } from '../../../../Base/Services/ToastService';
import AutoCompleteDropdown from '../../../../Base/Components/Form/AutoCompleteDropdown';
import { downloadFile, 
  uploadHandlerBICProveedores, 
  uploadHandlerConstanciaProveedores, 
  uploadHandlerEscrituraProveedores, 
  uploadHandlerFacturaProveedores, 
  uploadHandlerFormatoProveedores, 
  uploadHandlerPermisoProveedores, 
  uploadHandlerRegistroProveedores } from '../../../../Base/Services/ArchivosService';
import { ConfigContext } from '../../../../Base/Context/ConfigContext/ConfigContext';
import { getCountriesList } from '../../../../Base/API/Global/Countries/CountriesRequests';
import { getPublicCurrency } from '../../../../Base/API/Global/Currency/CurrencyRequest';
import { getInformacionEmpresa, getInformacionEmpresaPublic} from '../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest';

// ------------------- CONSULTAS A LA API---------------------------
import { getBancosList } from '../../../../API/Global/Bancos/BancosRequest';
import { getProveedorInfo, 
  getArchivosBIC,
  descargarArchivoBIC,
  eliminarArchivoBIC,
  getArchivosFactura,
  descargarArchivoFactura,
  descargarArchivoPermiso,
  descargarArchivoEscritura,
  descargarArchivoConstancia,
  eliminarArchivoFactura,
  eliminarArchivoPermiso,
  eliminarArchivoEscritura,
  eliminarArchivoConstancia,
  getArchivosPermiso,
  getArchivosEscritura,
  getArchivosConstancia,
  getArchivosRegistro,
  eliminarArchivoRegistro,
  descargarArchivoRegistro,
  getArchivosFormato,
  descargarArchivoFormato,
  eliminarArchivoFormato,
  getProveedorInfoPorId,
  GuardarInscripcion,
  getListaCorreosPublic,
  sendEmailInscripcion,
  saveRegistroExonerado,
  getRegistrosExonerados,} from '../../../../API/Compras/Proveedores/ProveedoresRequest';

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { InscripcionProveedoresLang } from './Lang/InscripcionProveedoresLang';
import FormatoInscripcionPDF from './FormatoInscripcion/FormatoInscripcion';
import DialogEstadoRevision from './DialogEstadoRevision';
import './Styles/Proveedores.scss'


const InscripcionProveedores = () => {
  const { config, changeTheme } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const params = useParams();
  const Token = params.Token;
  const lang = params.lang !== 'null' ? params.lang : 'es';
  const toast = useRef(null);
  const IdHonduras = 95;

  // REFERENCIAS DE FILEUPLOAD
  const fileUpload = useRef(null);
  const fileUploadBIC = useRef(null);
  const fileUploadFactura = useRef(null);
  const fileUploadPermiso = useRef(null);
  const fileUploadEscritura = useRef(null);
  const fileUploadConstancia = useRef(null);
  const fileUploadRegistro = useRef(null);
  const fileUploadFormato = useRef(null);

  const [tokenInfo, setTokenInfo] = useState(null);
  const [idCustomer, setIdCustomer] = useState(null);
  const [Bancos, setBancos] = useState([]);
  const [Countries, setCountries] = useState([]);
  const [Currencies, setCurrencies] = useState([]);
  const [infoEmpresa, setInfoEmpresa] = useState({});

  const [showMessages, setShowMessages] = useState({ error: false });
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogIncompleta, setShowDialogIncompleta] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editable, setEditable] = useState(true);
  const [ArchivoSelected, setArchivoSelected] = useState(0);
  const [idioma, setIdioma] = useState(lang || 'es');
  const [validar, setValidar] = useState(false);
  const [showDialogFormato, setShowDialogFormato] = useState(false);
  const [showDialogEstadoRevision, setShowDialogEstadoRevision] = useState(false);

  const [editable2, setEditable2] = useState(false);
  const [botonRegistro, setBotonRegistro] = useState(false);
  const [solicitudEdicionActiva, setSolicitudEdicionActiva] = useState(null);


  // ARCHIVOS
  const [listadoArchivos, setListadoArchivos] = useState([]);
  const [listadoArchivosFactura, setListadoArchivosFactura] = useState([]);
  const [listadoArchivosPermiso, setListadoArchivosPermiso] = useState([]);
  const [listadoArchivosEscritura, setListadoArchivosEscritura] = useState([]);
  const [listadoArchivosConstancia, setListadoArchivosConstancia] = useState([]);
  const [listadoArchivosRegistro, setListadoArchivosRegistro] = useState([]);
  const [listadoArchivosFormato, setListadoArchivosFormato] = useState([]);
  const [incompleta, setIncompleta] = useState(true);
  const [listaFaltantes, setListaFaltantes] = useState([]);
  const [dialogFinal, setDialogFinal] = useState(false);

  // Funciona que Valida la Edicion de los Campos
  const isFieldEditable = (seccion) => {
    const tieneSolicitudEdicion =
      solicitudEdicionActiva?.IdSolicitudEdicion &&
      solicitudEdicionActiva?.EstadoSolicitud === "Aprobada";

    if (tieneSolicitudEdicion) {
      if (solicitudEdicionActiva?.HabilitarPago || solicitudEdicionActiva?.Reactivar) {
        return false;
      }

      return (
        solicitudEdicionActiva?.[seccion] === true ||
        solicitudEdicionActiva?.[seccion] === 1
      );
    }

    return editable;
  };
  const tieneSolicitudEdicionAprobada = solicitudEdicionActiva?.IdSolicitudEdicion && solicitudEdicionActiva?.EstadoSolicitud === "Aprobada";


  const initialValues = {
    CustomerName: '',
    NombreComercial: '', // CustomerName
    numeroIdentificacionTributaria: '', //RTN
    Country: null, //Country
    State: '', //State
    City: '',
    Address: '', // DIRECCION COMERCIALBICBIC
    // Tel: '', // TELEFONO DE REFERENCIA
    Contac: '', // TELEFONO DE REFERENCIA
    Email: '', // EMAIL
    PrincipalActividadEconomica: '',
    TipoFacturacion: null, // TIPO DE FACTURACION
    CasaMatriz: '',
    DireccionCasaMatriz: '',

    // CONTACTO REPRESENTANTE LEGAL
    NombreRepresentanteLegal: '',
    CorreoRepresentanteLegal: '',

    // CONTACTO CUENTAS POR COBRAR
    ContactoCuentasPorCobrar: '',
    CorreoCuentasPorCobrar: '',
    TelefonoCuentasPorCobrar: '',

    // INFORMACION BANCARIA HONDURAS
    NumeroCuentaBancaria: '',
    TitularCuenta: '',
    Banco: null,
    TipoCuenta: null,
    Currency: null,
    BancoPais: null,

    NumeroCuentaBancaria2: '',
    TitularCuenta2: '',
    Banco2: null,
    TipoCuenta2: null,
    Currency2: null,

    // INFORMACION BANCARIA EXTRANJERO
    // BANCO INTERMEDIARIO
    BancoIntermediarioNombre: '',
    BancoIntermediarioDireccion: '',
    BancoIntermediarioSwift: '',
    BancoIntermediarioAbaBin: '',
    BancoIntermediarioCuenta: '',

    // BANCO BENEFCIARIO
    BancoBeneficiarioNombre: '',
    BancoBeneficiarioDireccion: '',
    BancoBeneficiarioSwift: '',
    BancoBeneficiarioNombreBeneficiario: '',
    BancoBeneficiarioCuenta: '',
    BancoBeneficiarioAbaBin: '',

    // INFORMACION FINANCIERA
    CurrencyFin: null,
    ActivosCorrientes: null,
    TotalActivos: null,
    PasivosCorrientes: null,
    TotalPasivos: null,

    // REFERENCIAS COMERCIALES
    ref1Nombre: '',
    ref1Telefono: '',
    ref1Correo: '',
    ref2Nombre: '',
    ref2Telefono: '',
    ref2Correo: '',

    refFin1Nombre:'',
    refFin1Correo:'',
    refFin1Telefono:'',
    refFin2Nombre:'',
    refFin2Correo:'',
    refFin2Telefono:'',

    // DOCUMENTACION
    FileRTN: null,
    FilePermisoOperaciones: null,
    FileNacional: null,
    FileEscrituraConstitucion: null,

    // AUTORIZACION
    AutorizacionDeposito: false,
    selectedOption: null,

    // ZONA LIBRE
    ZonaLibre: false,
    NombreZonaLibre: null,
    DireccionZonaLibre: null,
    RegistroExonerado: '',
    FechaInicio: null,
    FechaVencimiento: null,
    SinRegistroExonerado: false,
    TieneConstPagosCuenta: false,
  }
  
  const {values, handleInputChange, setValues} = useForm(initialValues);

  useEffect(() => {
    const esBancoHonduras = values?.BancoPais?.IdCountry === IdHonduras;
    const idBanco = values?.Banco?.IdBanco;

    const requiereFormaPago =
      esBancoHonduras && idBanco && ![2, 19].includes(idBanco);

    if (!requiereFormaPago && values?.selectedOption) {
      setValues((prev) => ({
        ...prev,
        selectedOption: null,
      }));
    }
  }, [values?.BancoPais, values?.Banco]);

  // Función para manejar la selección de la forma de pago del banco
  const handleFormaPagoBanco = (option) => {
    setValues({
      ...values,
      selectedOption: values.selectedOption === option ? null : option,
    });

    setShowMessages({
      ...showMessages,
      selectedOption: false,
      Banco: false,
    });
  };

  const tiposFactura = [
   { tipo: "Facturación Electrónica", type: "Electronic billing" },
   { tipo: "Facturación Física", type: "Physical billing" },
   {
     tipo: "Boleta por honorarios profesionales",
     type: "Invoice for professional services",
   },
  ];

  const tiposCuentas = [
    { tipo: 'Ahorros' },
    { tipo: 'Corriente' }
  ]

  const getCompanyInfo = async (IdCustomer) => {
    setLoading(true);
    const IdCus =
    typeof IdCustomer === "object"
      ? IdCustomer
      : { IdCustomer: IdCustomer || idCustomer };

    const result = await getProveedorInfo(IdCus, Token);

    if (result.length > 0) {
      const bancosT = await getBancosList(Token);
      const contriesT = await getCountriesList(Token);
      const currenciesT = await getPublicCurrency(Token);
      const bancosList = Array.isArray(bancosT) ? bancosT : [];
      const countriesList = Array.isArray(contriesT) ? contriesT : [];
      const currenciesList = Array.isArray(currenciesT) ? currenciesT : [];

      const pais = countriesList.find(x => Number(x.IdCountry) === Number(result[0].IdCountry));
      const banco = bancosList.find(x => Number(x.IdBanco) === Number(result[0].IdBanco));
      const bancoPais = countriesList.find(x => Number(x.IdCountry) === Number(result[0].BancoPais));
      const moneda = currenciesList.find( x => Number(x.IdCurrency) === Number(result[0].IdCurrency));
      const monedaFin = currenciesList.find(x => Number(x.IdCurrency) === Number(result[0].CurrencyFin));

      const banco2 = bancosList.find(x => Number(x.IdBanco) === Number(result[0].IdBanco2));
      const moneda2 = currenciesList.find(x => Number(x.IdCurrency) === Number(result[0].IdCurrency2));
      const tipoCuenta2 = tiposCuentas.find(x => x.tipo === result[0].TipoCuenta2);

      const tipoFactura = tiposFactura.find(x => x.tipo === result[0].TipoFacturacion);
      const tipoCuenta = tiposCuentas.find(x => x.tipo === result[0].TipoCuenta);
      const registros = await getRegistrosExonerados(result[0].IdVendor, Token);
      const reg = Array.isArray(registros) && registros.length > 0 ? registros[0] : null;
      setEditable(result[0]?.esEditable !== undefined ? result[0]?.esEditable : true)

      setValues({
        ...result[0],

        NombreComercial: result[0].NombreComercial ? result[0].NombreComercial : result[0].CustomerName,
        CustomerName: result[0].CustomerName,
        CodigoProveedor: result[0].CodigoProveedor,
        numeroIdentificacionTributaria: result[0].numeroIdentificacionTributaria,
        RTN: result[0].RTN,
        Country: pais,
        TipoFacturacion: tipoFactura,
        Banco: banco,
        TipoCuenta: tipoCuenta,
        Currency: moneda,

        NumeroCuentaBancaria2: result[0].NumeroCuentaBancaria2,
        TitularCuenta2: result[0].TitularCuenta2,
        Banco2: banco2,
        TipoCuenta2: tipoCuenta2,
        Currency2: moneda2,

        AutorizacionDeposito: result[0].AutorizacionDeposito,
        selectedOption: result[0].FormaPagoBanco || null,
        BancoPais: bancoPais || null,

        CurrencyFin: monedaFin,
        ActivosCorrientes: result[0].ActivosCorrientes,
        TotalActivos: result[0].TotalActivos,
        PasivosCorrientes: result[0].PasivosCorrientes,
        TotalPasivos: result[0].TotalPasivos,

        // Registros exonerados / constancia
        IdRegistro: reg?.IdRegistro || null,
        RegistroExonerado: reg?.RegistroExonerado || '',
        FechaInicio: reg?.FechaInicio ? new Date(reg.FechaInicio) : null,
        FechaVencimiento: reg?.FechaVencimiento ? new Date(reg.FechaVencimiento) : null,
        NombreZonaLibre: reg?.NombreZona || '',
        DireccionZonaLibre: reg?.DireccionZona || '',
        RegistroExoneradoName: reg?.RegistroExoneradoName || null,
        ConstPagosName: reg?.ConstPagosName || null,
        TieneConstPagosCuenta: reg?.TieneConstPagosCuenta || false,
        SinRegistroExonerado: reg?.Zoli && !reg?.RegistroExonerado ? true : false,
      });
      console.log("INFO PROVEEDOR SOLICITUD EDICION:", result[0]);
      setSolicitudEdicionActiva({
        InformacionEmpresa: result[0]?.InformacionEmpresa,
        InformacionContacto: result[0]?.InformacionContacto,
        InformacionBancaria: result[0]?.InformacionBancaria,
        InformacionComercial: result[0]?.InformacionComercial,
        InformacionFinanciera: result[0]?.InformacionFinanciera,
        Documentacion: result[0]?.Documentacion,
        HabilitarPago: result[0]?.HabilitarPago,
        Reactivar: result[0]?.Reactivar,
        IdSolicitudEdicion: result[0]?.IdSolicitudEdicion,
        IdEstadoSolicitud: result[0]?.IdEstadoSolicitud,
        EstadoSolicitud: result[0]?.EstadoSolicitud,
      });
      console.log("SOLICITUD EDICION ACTIVA:", {
        IdSolicitudEdicion: result[0]?.IdSolicitudEdicion,
        IdEstadoSolicitud: result[0]?.IdEstadoSolicitud,
        EstadoSolicitud: result[0]?.EstadoSolicitud,
        InformacionEmpresa: result[0]?.InformacionEmpresa,
        InformacionContacto: result[0]?.InformacionContacto,
        InformacionBancaria: result[0]?.InformacionBancaria,
        InformacionComercial: result[0]?.InformacionComercial,
        InformacionFinanciera: result[0]?.InformacionFinanciera,
        Documentacion: result[0]?.Documentacion,
        HabilitarPago: result[0]?.HabilitarPago,
        Reactivar: result[0]?.Reactivar,
      });
      setArchivoSelected(reg ? (reg.Zoli ? 1 : 0) : (result[0].ZonaLibre ? 1 : 0));

      const archivo = await getArchivosBIC(result[0].CodigoProveedor, Token);
      setListadoArchivos(Array.isArray(archivo) ? archivo : []);

      const archivoFactura = await getArchivosFactura(result[0].CodigoProveedor, Token);
      setListadoArchivosFactura(Array.isArray(archivoFactura) ? archivoFactura : []);
  
      const archivoPermiso = await getArchivosPermiso(result[0].CodigoProveedor, Token);
      setListadoArchivosPermiso(Array.isArray(archivoPermiso) ? archivoPermiso : []);

      const archivoEscritura = await getArchivosEscritura(result[0].CodigoProveedor, Token);
      setListadoArchivosEscritura(Array.isArray(archivoEscritura) ? archivoEscritura : []);

      const archivoConstancia = await getArchivosConstancia(result[0].CodigoProveedor, Token);
      setListadoArchivosConstancia(Array.isArray(archivoConstancia) ? archivoConstancia : []);

      const archivoRegistro = await getArchivosRegistro(result[0].CodigoProveedor, Token);
      setListadoArchivosRegistro(Array.isArray(archivoRegistro) ? archivoRegistro : []);

      const archivoFormato = await getArchivosFormato(result[0].CodigoProveedor, Token);
      setListadoArchivosFormato(Array.isArray(archivoFormato) ? archivoFormato : []);

      setEditable2(false);
      setBotonRegistro(false);

    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }

  const getInfo = async () => {
    const bancosT = await getBancosList(Token);
    const contriesT = await getCountriesList(Token);
    const currenciesT = await getPublicCurrency(Token);
    let infoEmpresaT = [];

    if (userAuth?.IdUser) {
      infoEmpresaT = await getInformacionEmpresa();
    } else {
      infoEmpresaT = await getInformacionEmpresaPublic(Token);
    }

    setBancos(bancosT);
    setCountries(contriesT);
    setCurrencies(currenciesT);
    setInfoEmpresa(infoEmpresaT?.[0] || {});
  }

  const getImageSrc = (img) => {
    if (!img || typeof img !== "string") return "";

    const limpia = img.trim();

    if (!limpia) return "";

    if (limpia.startsWith("data:image/")) {
      return limpia;
    }

    return `data:image/png;base64,${limpia}`;
  };

  const isLightTheme = config.theme?.toLowerCase() === "light";
  const logoFormulario = isLightTheme? getImageSrc(infoEmpresa?.LogoPrimarioB64 || infoEmpresa?.LogoPrimario || infoEmpresa?.LogoPrimarioVertical)
  : getImageSrc(infoEmpresa?.LogoPrimarioDarkB64 || infoEmpresa?.LogoPrimarioDark || infoEmpresa?.LogoPrimarioVerticalDark || infoEmpresa?.LogoPrimarioB64 || infoEmpresa?.LogoPrimario || infoEmpresa?.LogoPrimarioVertical);

  const verificarCampos = () => {
    let errors = {};
    let isValid = true;

    // INFOREMACION GENERAL
    if (!values.NombreComercial) {
      errors.NombreComercial = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.numeroIdentificacionTributaria) {
      errors.numeroIdentificacionTributaria = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Country) {
      errors.Country = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.State) {
      errors.State = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.City) {
      errors.City = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Address) {
      errors.Address = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Contact) {
      errors.Contact = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.Email) {
      errors.Email = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.PrincipalActividadEconomica) {
      errors.PrincipalActividadEconomica = true;
      errors.General = true;
      isValid = false;
    }
    if (!values.TipoFacturacion) {
      errors.TipoFacturacion = true;
      errors.General = true;
      isValid = false;
    }

    // CONTACTO CUENTAS POR COBRAR
    if (!values.ContactoCuentasPorCobrar) {
      errors.ContactoCuentasPorCobrar = true;
      errors.CuentasPorCobrar = true;
      isValid = false;
    }
    if (!values.CorreoCuentasPorCobrar) {
      errors.CorreoCuentasPorCobrar = true;
      errors.CuentasPorCobrar = true;
      isValid = false;
    }
    if (!values.TelefonoCuentasPorCobrar) {
      errors.TelefonoCuentasPorCobrar = true;
      errors.CuentasPorCobrar = true;
      isValid = false;
    }
    if (!values.Currency) {
      errors.Currency = true;
      errors.Banco = true;
      isValid = false;
    }

    // CONTACTOS FINANZAS
    if (!values.refFin1Nombre) {
      errors.refFin1Nombre = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }
    if (!values.refFin1Telefono) {
      errors.refFin1Telefono = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }
    if (!values.refFin1Correo) {
      errors.refFin1Correo = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }
    if (!values.refFin2Nombre) {
      errors.refFin2Nombre = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }
    if (!values.refFin2Telefono) {
      errors.refFin2Telefono = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }
    if (!values.refFin2Correo) {
      errors.refFin2Correo = true;
      errors.ConcactoFinanzas = true;
      isValid = false;
    }

   // INFORMACION BANCARIA
    if (!values.BancoPais) {
      errors.BancoPais = true;
      errors.Banco = true;
      isValid = false;
    }
    if (values?.BancoPais?.IdCountry === IdHonduras) {
      const cuenta1Completa =
        values?.NumeroCuentaBancaria &&
        values?.TitularCuenta &&
        values?.Banco?.IdBanco &&
        values?.TipoCuenta &&
        values?.Currency;

      const cuenta2Completa =
        values?.NumeroCuentaBancaria2 &&
        values?.TitularCuenta2 &&
        values?.Banco2?.IdBanco &&
        values?.TipoCuenta2 &&
        values?.Currency2;

      if (!cuenta1Completa && !cuenta2Completa) {
        if (!values?.NumeroCuentaBancaria) {
          errors.NumeroCuentaBancaria = true;
        }

        if (!values?.TitularCuenta) {
          errors.TitularCuenta = true;
        }

        if (!values?.Banco?.IdBanco) {
          errors.BancoCampo = true;
        }

        if (!values?.TipoCuenta) {
          errors.TipoCuenta = true;
        }

        if (!values?.Currency) {
          errors.Currency = true;
        }

        if (!values?.NumeroCuentaBancaria2) {
          errors.NumeroCuentaBancaria2 = true;
        }

        if (!values?.TitularCuenta2) {
          errors.TitularCuenta2 = true;
        }

        if (!values?.Banco2?.IdBanco) {
          errors.Banco2 = true;
        }

        if (!values?.TipoCuenta2) {
          errors.TipoCuenta2 = true;
        }

        if (!values?.Currency2) {
          errors.Currency2 = true;
        }

        errors.Banco = true;
        isValid = false;
      }

      // Si el banco NO es Atlántida ni Ficohsa, debe seleccionar forma de pago
      const requiereFormaPago =
        values?.BancoPais?.IdCountry === IdHonduras &&
        values?.Banco?.IdBanco &&
        ![2, 19].includes(values.Banco.IdBanco);

      if (requiereFormaPago && !values.selectedOption) {
        errors.selectedOption = true;
        errors.Banco = true;
        isValid = false;
      }

    } else {

      // BANCOS EXTRANJEROS
      if (!values.Currency) {
        errors.Currency = true;
        errors.Banco = true;
        isValid = false;
      }

      if (!values.BancoBeneficiarioNombre) {
        errors.BancoBeneficiarioNombre = true;
        errors.Banco = true;
        isValid = false;
      }

      if (!values.BancoBeneficiarioDireccion) {
        errors.BancoBeneficiarioDireccion = true;
        errors.Banco = true;
        isValid = false;
      }

      if (!values.BancoBeneficiarioSwift) {
        errors.BancoBeneficiarioSwift = true;
        errors.Banco = true;
        isValid = false;
      }

      if (!values.BancoBeneficiarioNombreBeneficiario) {
        errors.BancoBeneficiarioNombreBeneficiario = true;
        errors.Banco = true;
        isValid = false;
      }

      if (!values.BancoBeneficiarioAbaBin) {
        errors.BancoBeneficiarioAbaBin = true;
        errors.Banco = true;
        isValid = false;
      }

      if (!values.BancoBeneficiarioCuenta) {
        errors.BancoBeneficiarioCuenta = true;
        errors.Banco = true;
        isValid = false;
      }
    }

    // REFERENCIAS COMERCIALES
    if (!values.ref1Nombre) {
      errors.ref1Nombre = true;
      errors.ReferenciasComerciales = true;
      isValid = false;
    }
    if (!values.ref1Telefono) {
      errors.ReferenciasComerciales = true;
      errors.ref1Telefono = true;
      isValid = false;
    }
    if (!values.ref1Correo) {
      errors.ReferenciasComerciales = true;
      errors.ref1Correo = true;
      isValid = false;
    }
    if (!values.ref2Nombre) {
      errors.ReferenciasComerciales = true;
      errors.ref2Nombre = true;
      isValid = false;
    }
    if (!values.ref2Telefono) {
      errors.ReferenciasComerciales = true;
      errors.ref2Telefono = true;
      isValid = false;
    }
    if (!values.ref2Correo) {
      errors.ReferenciasComerciales = true;
      errors.ref2Correo = true;
      isValid = false;
    }


    // AUTORIZACION
    if (!values.AutorizacionDeposito) {
      errors.AutorizacionDeposito = true;
      isValid = false;
    }

    // ZONA LIBRE
    if ((values?.Country?.IdCountry === IdHonduras) || (values?.IdCountry === IdHonduras)) {
      if (ArchivoSelected === 1 && !values.SinRegistroExonerado) {
        if (!values.RegistroExonerado) {
          errors.RegistroExonerado = true;
          errors.Documentos = true;
          isValid = false;
        }

        if (!values.FechaInicio) {
          errors.FechaInicio = true;
          errors.Documentos = true;
          isValid = false;
        }

        if (!values.FechaVencimiento) {
          errors.FechaVencimiento = true;
          errors.Documentos = true;
          isValid = false;
        }

        if (!values.NombreZonaLibre) {
          errors.NombreZonaLibre = true;
          errors.Documentos = true;
          isValid = false;
        }

        if (!values.DireccionZonaLibre) {
          errors.DireccionZonaLibre = true;
          errors.Documentos = true;
          isValid = false;
        }
      }
    }

    // INFORMACION FINANCIERA
    if (!values.CurrencyFin) {
      errors.CurrencyFin = true;
      errors.Financiera = true;
      isValid = false;
    }

    if (!values.ActivosCorrientes) {
      errors.ActivosCorrientes = true;
      errors.Financiera = true;
      isValid = false;
    }

    if (!values.TotalActivos) {
      errors.TotalActivos = true;
      errors.Financiera = true;
      isValid = false;
    }

    if (!values.PasivosCorrientes) {
      errors.PasivosCorrientes = true;
      errors.Financiera = true;
      isValid = false;
    }

    if (!values.TotalPasivos) {
      errors.TotalPasivos = true;
      errors.Financiera = true;
      isValid = false;
    }


    if(values?.Country?.IdCountry === IdHonduras){
      if (!values?.BICName && !listadoArchivos?.length && !fileUploadBIC.current?.getFiles()?.length) {
          errors.BICName = true;
          isValid = false;
      }
      if (!values?.FacturaName && !listadoArchivosFactura?.length && !fileUploadFactura.current?.getFiles()?.length) {
        errors.FacturaName = true;
        isValid = false;
      }
      if (!values?.PermisoOperacionesName && !listadoArchivosPermiso?.length && !fileUploadPermiso.current?.getFiles()?.length) {
        errors.PermisoOperacionesName = true;
        isValid = false;
      }
      if (!values?.EscrituraConstitucionName && !listadoArchivosEscritura?.length && !fileUploadEscritura.current?.getFiles()?.length) {
        errors.EscrituraConstitucionName = true;
        isValid = false;
      }

      if(ArchivoSelected === 0){
        if (values?.TieneConstPagosCuenta && !values?.FechaInicio) {
          errors.FechaInicio = true;
          errors.Documentos = true;
          isValid = false;
        }

        if (values?.TieneConstPagosCuenta && !values?.FechaVencimiento) {
          errors.FechaVencimiento = true;
          errors.Documentos = true;
          isValid = false;
        }

        if (
          values?.TieneConstPagosCuenta &&
          !values?.ConstPagosName &&
          !listadoArchivosConstancia?.length &&
          !fileUploadConstancia.current?.getFiles()?.length
        ) {
          errors.ConstPagosName = true;
          errors.Documentos = true;
          isValid = false;
        }
      }else{
        if (
          !values.SinRegistroExonerado &&
          !values?.RegistroExoneradoName &&
          !listadoArchivosRegistro?.length &&
          !fileUploadRegistro.current?.getFiles()?.length
        ) {
          errors.RegistroExoneradoName = true;
          errors.Documentos = true;
          isValid = false;
        }
      }

    }else{
      if (!values?.BICName && !listadoArchivos?.length &&
        !fileUploadBIC.current?.getFiles()?.length
      ) {
        errors.BICName = true;
        errors.Documentos = true;
        isValid = false;
      }

      if (
        !values?.FacturaName &&
        !listadoArchivosFactura?.length &&
        !fileUploadFactura.current?.getFiles()?.length
      ) {
        errors.FacturaName = true;
        errors.Documentos = true;
        isValid = false;
      }
    }

    setShowMessages({ ...errors, error: !isValid });

    const labelsEs = {
      NombreComercial: "Nombre Comercial",
      numeroIdentificacionTributaria: "Número de Identificación Tributaria",
      Country: "País",
      BancoPais: "Banco País",
      selectedOption: "Debe seleccionar una opción de pago",
      State: "Departamento",
      City: "Ciudad",
      Address: "Dirección",
      Contact: "Teléfono de Referencia",
      Email: "Correo Electrónico",
      PrincipalActividadEconomica: "Actividad Económica",
      TipoFacturacion: "Tipo de Facturación",  
      ContactoCuentasPorCobrar: "Contacto Cuentas por Cobrar",
      CorreoCuentasPorCobrar: "Correo Cuentas por Cobrar",
      TelefonoCuentasPorCobrar: "Teléfono Cuentas por Cobrar",
      refFin1Nombre: "Nombre Referencia Financiera 1",
      refFin1Telefono: "Teléfono Referencia Financiera 1",
      refFin1Correo: "Correo Referencia Financiera 1",
      refFin2Nombre: "Nombre Referencia Financiera 2",
      refFin2Telefono: "Teléfono Referencia Financiera 2",
      refFin2Correo: "Correo Referencia Financiera 2",
      BancoCampo: "Banco",
      TipoCuenta: "Tipo de Cuenta",
      NumeroCuentaBancaria: "Número de Cuenta Bancaria",
      TitularCuenta: "Titular de la Cuenta",

      NumeroCuentaBancaria2: "Número de Cuenta Bancaria en Dólares",
      TitularCuenta2: "Titular de la Cuenta en Dólares",
      Banco2: "Banco de Cuenta en Dólares",
      TipoCuenta2: "Tipo de Cuenta en Dólares",
      Currency2: "Moneda de Cuenta en Dólares",

      BancoBeneficiarioNombre: "Nombre del Banco Beneficiario",
      BancoBeneficiarioAbaBin: "ABA/BIN del Banco Beneficiario",
      BancoBeneficiarioDireccion: "Dirección del Banco Beneficiario",
      BancoBeneficiarioSwift: "SWIFT del Banco Beneficiario",
      BancoBeneficiarioNombreBeneficiario: "Nombre del Beneficiario",
      BancoBeneficiarioCuenta: "Cuenta del Beneficiario",
      ref1Nombre: "Nombre Referencia Comercial 1",
      ref1Telefono: "Teléfono Referencia Comercial 1",
      ref1Correo: "Correo Referencia Comercial 1",
      ref2Nombre: "Nombre Referencia Comercial 2",
      ref2Telefono: "Teléfono Referencia Comercial 2",
      ref2Correo: "Correo Referencia Comercial 2",
      NombreZonaLibre: "Nombre de Zona Libre",
      DireccionZonaLibre: "Dirección de Zona Libre",
      RegistroExonerado: "Número Registro Exonerado",
      FechaInicio: "Fecha Inicio Constancia de Pagos",
      FechaVencimiento: "Fecha Vencimiento Constancia de Pagos",
      BICName: "Archivo BIC",
      FacturaName: "Archivo Factura",
      PermisoOperacionesName: "Archivo Permiso de Operaciones",
      EscrituraConstitucionName: "Archivo Escritura de Constitución",
      ConstPagosName: "Archivo Constancia de Pagos",
      RegistroExoneradoName: "Archivo Registro Exonerado",
      AutorizacionDeposito: "Autorización de Depósito"
    };

    const labelsEn = {
      NombreComercial: "Commercial Name",
      numeroIdentificacionTributaria: "Tax Identification Number",
      Country: "Country",
      BancoPais: "Bank Country",
      selectedOption: "You must select a payment option",
      State: "State/Province",
      City: "City",
      Address: "Address",
      Contact: "Reference Phone",
      Email: "Email",
      PrincipalActividadEconomica: "Economic Activity",
      TipoFacturacion: "Billing Type",
      ContactoCuentasPorCobrar: "Accounts Receivable Contact",
      CorreoCuentasPorCobrar: "Accounts Receivable Email",
      TelefonoCuentasPorCobrar: "Accounts Receivable Phone",
      refFin1Nombre: "Financial Reference 1 Name",
      refFin1Telefono: "Financial Reference 1 Phone",
      refFin1Correo: "Financial Reference 1 Email",
      refFin2Nombre: "Financial Reference 2 Name",
      refFin2Telefono: "Financial Reference 2 Phone",
      refFin2Correo: "Financial Reference 2 Email",
      BancoCampo: "Bank",
      TipoCuenta: "Account Type",
      NumeroCuentaBancaria: "Bank Account Number",
      TitularCuenta: "Account Holder",

      NumeroCuentaBancaria2: "Dollar Bank Account Number",
      TitularCuenta2: "Dollar Account Holder",
      Banco2: "Dollar Account Bank",
      TipoCuenta2: "Dollar Account Type",
      Currency2: "Dollar Account Currency",

      BancoBeneficiarioNombre: "Beneficiary Bank Name",
      BancoBeneficiarioAbaBin: "Beneficiary Bank ABA/BIN",
      BancoBeneficiarioDireccion: "Beneficiary Bank Address",
      BancoBeneficiarioSwift: "Beneficiary Bank SWIFT",
      BancoBeneficiarioNombreBeneficiario: "Beneficiary Name",
      BancoBeneficiarioCuenta: "Beneficiary Account",
      ref1Nombre: "Commercial Reference 1 Name",
      ref1Telefono: "Commercial Reference 1 Phone",
      ref1Correo: "Commercial Reference 1 Email",
      ref2Nombre: "Commercial Reference 2 Name",
      ref2Telefono: "Commercial Reference 2 Phone",
      ref2Correo: "Commercial Reference 2 Email",
      NombreZonaLibre: "Free Zone Name",
      DireccionZonaLibre: "Free Zone Address",
      RegistroExonerado: "Exonerated Registration Number",
      FechaInicio: "Payment Certification Start Date",
      FechaVencimiento: "Payment Certification Expiration Date", 
      BICName: "BIC File",
      FacturaName: "Invoice File",
      PermisoOperacionesName: "Operating Permit File",
      EscrituraConstitucionName: "Articles of Incorporation File",
      ConstPagosName: "Payment Certification File",
      RegistroExoneradoName: "Exemption Registration File",
      AutorizacionDeposito: "Deposit Authorization"
    };

    const labels = idioma === 'es' ? labelsEs : labelsEn;
    const listaFaltantes = Object.keys(errors)
    .filter(key => errors[key])
    .map(key => labels[key] || '');

    setListaFaltantes(listaFaltantes, errors);

    if (Object.keys(errors).length === 0 && isValid) {
      setIncompleta(false)
    } else {
      setIncompleta(true)
    }

    return {
      isValid,
      errors,
      listaFaltantes,
    };
  }

  const referencia = {
   IdRef: idCustomer,
   Codigo: values?.CodigoProveedor,
  };

  const headerUploadTemplate = (options) => {
    const { chooseButton } = options;

    return (
      <div className="p-fileupload-buttonbar">
        {chooseButton}
      </div>
    );
  };

  //SUBIR ARCHIVOS -------------------------------------------------------------------------------------
  const subirFileBIC = async (e) => {
    const result = await getProveedorInfoPorId(idCustomer, Token);

    if (result[0].BICName !== null) {
      await eliminarArchivoBIC(result[0].CodigoProveedor, result[0].BICName, Token);
    } 
    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: referencia.IdRef,
      },
      {
        name: "Codigo",
        type: "text",
        value: referencia.Codigo,
      },
    ];
    await uploadHandlerBICProveedores({ e, inputs, toast, ref: fileUploadBIC, Token });
    await getArchivos(); 
  };

  const subirFileFactura = async (e) => {
    const result = await getProveedorInfoPorId(idCustomer, Token);

    if(result[0].FacturaName !== null){
      await eliminarArchivoFactura(result[0].CodigoProveedor ,result[0].FacturaName)
    }

    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: referencia.IdRef,
      },
      {
        name: "Codigo",
        type: "text",
        value: referencia.Codigo,
      },
    ];
    await uploadHandlerFacturaProveedores({ e, inputs, toast, ref: fileUploadFactura, Token });
    await getArchivosFact();
  };

  const subirFilePermiso = async (e) => {
    const result = await getProveedorInfoPorId(idCustomer, Token);

    if(result[0].PermisoOperacionesName !== null){
      await eliminarArchivoPermiso(result[0].CodigoProveedor ,result[0].PermisoOperacionesName)
    }
    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: referencia.IdRef,
      },
      {
        name: "Codigo",
        type: "text",
        value: referencia.Codigo,
      },
    ];
    await uploadHandlerPermisoProveedores({ e, inputs, toast, ref: fileUploadPermiso, Token });
    await getArchivosPerm();
  };

  const subirFileEscritura = async (e) => {
    const result = await getProveedorInfoPorId(idCustomer, Token);

    if(result[0].EscrituraConstitucionName !== null){
      await eliminarArchivoEscritura(result[0].CodigoProveedor ,result[0].EscrituraConstitucionName)
    }
    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: referencia.IdRef,
      },
      {
        name: "Codigo",
        type: "text",
        value: referencia.Codigo,
      },
    ];
    await uploadHandlerEscrituraProveedores({ e, inputs, toast, ref: fileUploadEscritura, Token });
    await getArchivosEsc();
  };

  const subirFileConstancia = async (e) => {
    if (values?.ConstPagosName) {
      await eliminarArchivoConstancia(values?.CodigoProveedor, values?.ConstPagosName, Token);
    }

    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: referencia.IdRef,
      },
      {
        name: "Codigo",
        type: "text",
        value: referencia.Codigo,
      },
    ];

    await uploadHandlerConstanciaProveedores({e, inputs, toast, ref: fileUploadConstancia, Token});
    await getArchivosCons();
  };

  const subirFileFormato = async (e) => {

    if (values?.FormatoInscripcionName) {
      await eliminarArchivoFormato(values?.CodigoProveedor, values?.FormatoInscripcionName, Token);
    }

    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: referencia.IdRef,
      },
      {
        name: "Codigo",
        type: "text",
        value: referencia.Codigo,
      },
    ];
    await uploadHandlerFormatoProveedores({e,inputs,toast,ref: fileUploadFormato,Token,});
    await getArchivosForm();
    fileUploadFormato.current?.clear();
    EnviarCorreoFormatoCompleto();
  };

  const subirFileRegistro = async (e) => {
    if (values?.RegistroExoneradoName) {
      await eliminarArchivoRegistro(values?.CodigoProveedor, values?.RegistroExoneradoName, Token);
    }

    const inputs = [
      {
        name: "IdRef",
        type: "text",
        value: referencia.IdRef,
      },
      {
        name: "Codigo",
        type: "text",
        value: referencia.Codigo,
      },
    ];

    await uploadHandlerRegistroProveedores({e, inputs,toast, ref: fileUploadRegistro,Token,});
    await getArchivosReg();
  };

  // OBTENER ARCHIVOS --------------------------------------------------------------------------------
  const getArchivos = async () => {
    const archivo = await getArchivosBIC(values?.CodigoProveedor, Token);
    setListadoArchivos(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };
  
  const getArchivosFact = async () => {
    const archivo = await getArchivosFactura(values?.CodigoProveedor, Token);
    setListadoArchivosFactura(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosPerm = async () => {
    const archivo = await getArchivosPermiso(values?.CodigoProveedor, Token);
    setListadoArchivosPermiso(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosEsc = async () => {
    const archivo = await getArchivosEscritura(values?.CodigoProveedor, Token);
    setListadoArchivosEscritura(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosCons = async () => {
    const archivo = await getArchivosConstancia(values?.CodigoProveedor, Token);
    setListadoArchivosConstancia(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosForm = async () => {
    const archivo = await getArchivosFormato(values?.CodigoProveedor, Token);
    setListadoArchivosFormato(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  const getArchivosReg = async () => {
    const archivo = await getArchivosRegistro(values?.CodigoProveedor, Token);
    setListadoArchivosRegistro(Array.isArray(archivo) ? archivo : []);
    setLoading(false);
    return archivo;
  };

  // GUARDAR INSCRIPCION --------------------------------------------------------------------------------
  const guardarInscripcion = async () => { 
    setLoading(true);

    if (fileUploadBIC.current?.getFiles()?.length > 0) {
      await fileUploadBIC.current.upload();
    }

    if (fileUploadFactura.current?.getFiles()?.length > 0) {
      await fileUploadFactura.current.upload();
    }

    if (fileUploadPermiso.current?.getFiles()?.length > 0) {
      await fileUploadPermiso.current.upload();
    }

    if (fileUploadEscritura.current?.getFiles()?.length > 0) {
      await fileUploadEscritura.current.upload();
    }

    if (fileUploadConstancia.current?.getFiles()?.length > 0) {
      await fileUploadConstancia.current.upload();
    }

    if (fileUploadRegistro.current?.getFiles()?.length > 0) {
      await fileUploadRegistro.current.upload();
    }

    const BIC = getArchivos();
    const ArchivoBIC = await BIC.then(resultado => resultado.length > 0 ? resultado[0] : '').catch(() => '');

    const PERM = getArchivosPerm();
    const ArchivoPERM = await PERM.then(resultado => resultado.length > 0 ? resultado[0] : '').catch(() => '');

    const FACT = getArchivosFact();
    const ArchivoFACT = await FACT.then(resultado => resultado.length > 0 ? resultado[0] : '').catch(() => '');

    const ESC = getArchivosEsc();
    const ArchivoESC = await ESC.then(resultado => resultado.length > 0 ? resultado[0] : '').catch(() => '');

    const CONS = getArchivosCons();
    const ArchivoCONS = await CONS.then(resultado => resultado.length > 0 ? resultado[0] : '').catch(() => '');

    const REG = getArchivosReg();
    const ArchivoREG = await REG.then(resultado => resultado.length > 0 ? resultado[0] : '').catch(() => '');

    // const FORM = getArchivosForm();
    // const ArchivoFORM = await FORM.then(resultado => resultado.length > 0 ? resultado[0] : '').catch(() => '');

    const Datos = {
      // Información de la Empresa
      IdVendor: idCustomer,
      CustomerName: values?.CustomerName,
      NombreComercial: values?.NombreComercial,
      // CustomerName: values?.NombreComercial ? values?.NombreComercial : values?.CustomerName,
      // RTN: values?.RTN,
      numeroIdentificacionTributaria: values?.numeroIdentificacionTributaria,
      IdCountry: values.Country?.IdCountry || values?.IdCountry,
      State: values?.State,
      City: values?.City,
      Address: values?.Address,
      Email: values?.Email,
      Contact: values?.Contact,
      PrincipalActividadEconomica: values?.PrincipalActividadEconomica,
      TipoFacturacion: values?.TipoFacturacion?.tipo || values?.TipoFacturacion,
      CasaMatriz: values?.CasaMatriz,
      DireccionCasaMatriz: values?.DireccionCasaMatriz,

      // Información de contacto del representante legal
      NombreRepresentanteLegal: values?.NombreRepresentanteLegal,
      CorreoRepresentanteLegal: values?.CorreoRepresentanteLegal,

      // Información de contacto de cuentas por cobrar
      ContactoCuentasPorCobrar: values?.ContactoCuentasPorCobrar,
      CorreoCuentasPorCobrar: values?.CorreoCuentasPorCobrar,
      TelefonoCuentasPorCobrar: values?.TelefonoCuentasPorCobrar,

      // Información contacto finanzas
      refFin1Nombre: values?.refFin1Nombre,
      refFin1Correo: values?.refFin1Correo,
      refFin1Telefono: values?.refFin1Telefono,
      refFin2Nombre: values?.refFin2Nombre,
      refFin2Correo: values?.refFin2Correo,
      refFin2Telefono: values?.refFin2Telefono,

      // Información bancaria
      NumeroCuentaBancaria: values?.NumeroCuentaBancaria,
      TitularCuenta: values?.TitularCuenta,
      IdBanco: values?.Banco?.IdBanco || values?.IdBanco,
      TipoCuenta: values?.TipoCuenta?.tipo || values?.TipoCuenta,
      IdCurrency: values.Currency?.IdCurrency || values?.IdCurrency,
      BancoPais: values?.BancoPais?.IdCountry || values?.BancoPais || null,

      // Información bancaria2
      NumeroCuentaBancaria2: values?.NumeroCuentaBancaria2,
      TitularCuenta2: values?.TitularCuenta2,
      IdBanco2: values?.Banco2?.IdBanco || values?.IdBanco2,
      Banco2: values?.Banco2?.NombreBanco || values?.Banco2,
      TipoCuenta2: values?.TipoCuenta2?.tipo || values?.TipoCuenta2,
      IdCurrency2: values?.Currency2?.IdCurrency || values?.IdCurrency2,

      // Información bancaria internacional - Banco intermediario
      BancoIntermediarioNombre: values?.BancoIntermediarioNombre,
      BancoIntermediarioDireccion: values?.BancoIntermediarioDireccion,
      BancoIntermediarioSwift: values?.BancoIntermediarioSwift,
      BancoIntermediarioAbaBin: values?.BancoIntermediarioAbaBin,
      BancoIntermediarioCuenta: values?.BancoIntermediarioCuenta,

      // Información bancaria internacional - Banco beneficiario
      BancoBeneficiarioNombre: values?.BancoBeneficiarioNombre,
      BancoBeneficiarioDireccion: values?.BancoBeneficiarioDireccion,
      BancoBeneficiarioSwift: values?.BancoBeneficiarioSwift,
      BancoBeneficiarioNombreBeneficiario: values?.BancoBeneficiarioNombreBeneficiario,
      BancoBeneficiarioAbaBin: values?.BancoBeneficiarioAbaBin,
      BancoBeneficiarioCuenta: values?.BancoBeneficiarioCuenta,

      // Informacion Financiera
      CurrencyFin: values?.CurrencyFin?.IdCurrency || values?.CurrencyFin,
      ActivosCorrientes: values?.ActivosCorrientes,
      TotalActivos: values?.TotalActivos,
      PasivosCorrientes: values?.PasivosCorrientes,
      TotalPasivos: values?.TotalPasivos,

      // Referencias Comerciales
      ref1Nombre: values?.ref1Nombre,
      ref1Telefono: values?.ref1Telefono,
      ref1Correo: values?.ref1Correo,
      ref2Nombre: values?.ref2Nombre,
      ref2Telefono: values?.ref2Telefono,
      ref2Correo: values?.ref2Correo,

      // Zona Libre
      ZonaLibre: ArchivoSelected === 1 ? true : false ,
      NombreZonaLibre: ArchivoSelected === 1 ? values?.NombreZonaLibre : null, 
      DireccionZonaLibre: ArchivoSelected === 1 ? values?.DireccionZonaLibre : null,

      // Documentación
      BICName: ArchivoBIC,
      FacturaName: ArchivoFACT,
      PermisoOperacionesName: ArchivoPERM,
      EscrituraConstitucionName: ArchivoESC,
      ConstPagosName: ArchivoSelected !== 1 ? ArchivoCONS : null,
      RegistroExoneradoName: ArchivoSelected === 1 ? ArchivoREG : null,

      Incompleta: incompleta, 
      Token: Token,
      esEditable: incompleta ? 1 : 0,
      AutorizacionDeposito: values?.AutorizacionDeposito,
      FormaPagoBanco: values?.selectedOption,
    }

    if (ArchivoSelected === 1) {
      eliminarConstanciaSinToast(values?.ConstPagosName)
    } else {
      eliminarRegistroSinToast(values?.RegistroExoneradoName)
    }

    const resp = await GuardarInscripcion(Datos, Token);
    if (resp?.[0]?.ESTADO === 1 && values?.Country?.IdCountry === IdHonduras) {
      const ArchivoCONSRegistro = ArchivoCONS || null;
      const ArchivoREGRegistro = ArchivoREG || null;

      const datosRegistro = {
        IdRegistro: values?.IdRegistro || null,
        IdProveedor: idCustomer,
        Zoli: ArchivoSelected === 1,

        RegistroExonerado: ArchivoSelected === 1 && !values?.SinRegistroExonerado
          ? values?.RegistroExonerado
          : null,

        FechaInicio: values?.FechaInicio || null,
        FechaVencimiento: values?.FechaVencimiento || null,

        NombreZona: ArchivoSelected === 1 ? values?.NombreZonaLibre : null,
        DireccionZona: ArchivoSelected === 1 ? values?.DireccionZonaLibre : null,

        RegistroExoneradoName: ArchivoSelected === 1 ? ArchivoREGRegistro : null,
        RegistroExoneradoArchivo: null,
        SinRegistroExonerado: ArchivoSelected === 1 ? values?.SinRegistroExonerado : false,

        ConstPagosName: ArchivoSelected === 0 ? ArchivoCONSRegistro : null,
        FileConstPagosCuenta: null,
        TieneConstPagosCuenta: ArchivoSelected === 0 ? values?.TieneConstPagosCuenta : false,

        IdEstado: 5,
      };

      await saveRegistroExonerado(datosRegistro, Token);
      setValues((prev) => ({
        ...prev,
        ConstPagosName: ArchivoSelected === 0 ? ArchivoCONSRegistro : null,
        RegistroExoneradoName: ArchivoSelected === 1 ? ArchivoREGRegistro : null,
      }));
    }
    if(resp[0]?.ESTADO === 1){
      setShowDialogIncompleta(false);
      toastShow(toast, 'success', incompleta ? setLabel('registroCompletoIncompleta') : setLabel('registroCompleto'));

      await getCompanyInfo({ IdCustomer: idCustomer });

      if (!incompleta) {
        setEditable(false);
        setSolicitudEdicionActiva(null);
        setDialogFinal(true);
      }
    }else{
      toastShow(toast, 'error', 'Error', setLabel('errorRegistro'));
    }
  }

  const EnviarCorreoFormatoCompleto = async () => {
    setShowDialog(false);

    const correos = await getListaCorreosPublic(10, Token);

    if (!Array.isArray(correos) || correos.length === 0) {
      toastShow(toast, "warn", "Advertencia", "No hay lista de correos configurada.");
      return;
    }

    const htmlContent = `
      <div>
        <h4>Notificación de Actualización de Información del Proveedor</h4>
        <p>El proveedor <strong>${values?.CustomerName || values?.NombreComercial}</strong>, con Código <strong>${values?.CodigoProveedor}</strong> ha actualizado su información.</p>
        <p>Por favor, revise la nueva información en el sistema.</p>
        <p>*Correo generado automáticamente, por favor no responder.</p>
        <p>Saludos cordiales.</p>
      </div>
    `;

    const objeto = {
      to: correos[0].DestinatariosMail,
      cc: correos[0].CCMail,
      bcc: correos[0].CCoMail,
      subject: correos[0].Asunto,
      html: htmlContent,
    };

    await sendEmailInscripcion(objeto, Token);
  };

  //DESCARGAR ARCHIVOS ----------------------------------------------------------------------------------
  const getArchivo = async (nombre) => {
    const a = await descargarArchivoBIC(values?.CodigoProveedor, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoFactura = async (nombre) => {
    const a = await descargarArchivoFactura(values?.CodigoProveedor, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoPermiso = async (nombre) => {
    const a = await descargarArchivoPermiso(values?.CodigoProveedor, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoEscritura = async (nombre) => {
    const a = await descargarArchivoEscritura(values?.CodigoProveedor, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoConstancia = async (nombre) => {
    const a = await descargarArchivoConstancia(values?.CodigoProveedor, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoRegistro = async (nombre) => {
    const a = await descargarArchivoRegistro(values?.CodigoProveedor, nombre, Token);
    downloadFile(a, nombre);
  };

  const getArchivoFormato = async (nombre) => {
    const a = await descargarArchivoFormato(values?.CodigoProveedor, nombre, Token);
    downloadFile(a, nombre);
  };


  //ELIMINAR ARCHIVOS --------------------------------------------------------------------------------------
  const eliminar = async (nombre) => {
    await eliminarArchivoBIC(values?.CodigoProveedor, nombre, Token);
    toastShow(toast, "success", "Cancelado", "Archivo BIC eliminado correctamente.");
    setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== nombre));
    setValues({
      ...values,
      BICName: null,
    })
  };

  const eliminarFactura = async (nombre) => {
    await eliminarArchivoFactura(values?.CodigoProveedor, nombre, Token);
    toastShow(
      toast,
      "success",
      "Cancelado",
      "Factura eliminada correctamente."
    );
    setListadoArchivosFactura(listadoArchivosFactura.filter((archivo) => archivo !== nombre));
    setValues({
      ...values,
      FacturaName: null,
    })
  };

  const eliminarPermiso = async (nombre) => {
    const a = await eliminarArchivoPermiso(values?.CodigoProveedor, nombre, Token);
    toastShow( toast, "success", "Cancelado", "Permiso eliminada correctamente." );
    setListadoArchivosPermiso(listadoArchivosPermiso.filter((archivo) => archivo !== nombre));
    setValues({
      ...values,
      PermisoOperacionesName: null,
    })
  };

  const eliminarEscritura = async (nombre) => {
    await eliminarArchivoEscritura(values?.CodigoProveedor, nombre, Token);
    toastShow( toast, "success", "Cancelado", "Escritura eliminada correctamente." );
    setListadoArchivosEscritura(listadoArchivosEscritura.filter((archivo) => archivo !== nombre));
    setValues({
      ...values,
      EscrituraConstitucionName: null,
    })
  };

  const eliminarConstancia = async (nombre) => {
    await eliminarArchivoConstancia(values?.CodigoProveedor, nombre, Token);
    toastShow(toast,"success","Cancelado","Constancia eliminada correctamente.");
    setListadoArchivosConstancia(listadoArchivosConstancia.filter((archivo) => archivo !== nombre));
    setValues({
      ...values,
      ConstPagosName: null,
    })
  };

  const eliminarRegistro = async (nombre) => {
    await eliminarArchivoRegistro(values?.CodigoProveedor, nombre, Token);
    toastShow(toast,"success","Cancelado", "Registro eliminada correctamente.");
    setListadoArchivosRegistro(listadoArchivosRegistro?.filter((archivo) => archivo !== nombre));
    setValues({
      ...values,
      RegistroExoneradoName: null,
    })
  };

  const eliminarFormato = async (nombre) => {
    await eliminarArchivoFormato(values?.CodigoProveedor, nombre, Token);
    toastShow(toast,"success","Cancelado","Registro eliminada correctamente.");
    setListadoArchivosFormato(listadoArchivosFormato.filter((archivo) => archivo !== nombre));
  };

  const eliminarRegistroSinToast = async (nombre) => {
    if (!nombre) return;
    await eliminarArchivoRegistro(values?.CodigoProveedor, nombre, Token);
    setListadoArchivosRegistro(listadoArchivosRegistro?.filter((archivo) => archivo !== nombre));
  };

  const eliminarConstanciaSinToast = async (nombre) => {
    if (!nombre) return;
    await eliminarArchivoConstancia(values?.CodigoProveedor, nombre, Token);
    setListadoArchivosConstancia(listadoArchivosConstancia.filter((archivo) => archivo !== nombre));
  };
  
  const setLabel = (key, params = {}) => {
    const label = InscripcionProveedoresLang[key]?.[idioma];

    if (typeof label === "function") {
      return label(params);
    }

    return label || key;
  };

  const limpiarZonaLibre = () => {
    setEditable2(true);
    setBotonRegistro(true);

    setListadoArchivosRegistro([]);
    setListadoArchivosConstancia([]);

    fileUploadRegistro.current?.clear?.();
    fileUploadConstancia.current?.clear?.();

    setValues(prev => ({
      ...prev,
      IdRegistro: null,

      RegistroExonerado: '',
      FechaVencimiento: null,
      FechaInicio: null,
      NombreZonaLibre: '',
      DireccionZonaLibre: '',
      RegistroExoneradoName: null,

      ConstPagosName: null,
      TieneConstPagosCuenta: false,

      SinRegistroExonerado: false,
    }));
  };

  const limpiarConstanciaPagos = () => {
    setEditable2(true);
    setBotonRegistro(true);

    setListadoArchivosRegistro([]);
    setListadoArchivosConstancia([]);

    fileUploadRegistro.current?.clear?.();
    fileUploadConstancia.current?.clear?.();

    setValues(prev => ({
      ...prev,
      IdRegistro: null,

      RegistroExonerado: '',
      NombreZonaLibre: '',
      DireccionZonaLibre: '',
      RegistroExoneradoName: null,
      SinRegistroExonerado: false,

      FechaInicio: null,
      FechaVencimiento: null,
      ConstPagosName: null,
      TieneConstPagosCuenta: true,
    }));
  };

  const verificarRegistroExonerado = (archivoRegistroGuardado = null, archivoConstanciaGuardado = null) => {
  let errors = {};

  if (ArchivoSelected === 0 && values?.TieneConstPagosCuenta) {
    if (!values.FechaInicio) {
      errors.FechaInicio = true;
    }

    if (!values.FechaVencimiento) {
      errors.FechaVencimiento = true;
    }

    if (!archivoConstanciaGuardado) {
      errors.ConstPagosName = true;
    }
  }

  if (ArchivoSelected === 1 && !values.SinRegistroExonerado) {
    if (!values.RegistroExonerado) errors.RegistroExonerado = true;
    if (!values.FechaInicio) errors.FechaInicio = true;
    if (!values.FechaVencimiento) errors.FechaVencimiento = true;
    if (!values.NombreZonaLibre) errors.NombreZonaLibre = true;
    if (!values.DireccionZonaLibre) errors.DireccionZonaLibre = true;

    if (!archivoRegistroGuardado) {
      errors.RegistroExoneradoName = true;
    }
  }

  const isValid = Object.keys(errors).length === 0;

  setShowMessages({ ...showMessages, ...errors, error: !isValid });

  if (!isValid) {
    toastShow(
      toast,
      "warn",
      "Advertencia",
      ArchivoSelected === 0
        ? "Complete los datos de la constancia de pagos."
        : "Complete los datos del registro exonerado."
    );
  }

  return isValid;
};

  const addRegistro = async () => {

    let archivoRegistroGuardado = listadoArchivosRegistro?.[0] || values?.RegistroExoneradoName;
    let archivoConstanciaGuardado = listadoArchivosConstancia?.[0] || values?.ConstPagosName;

    if (ArchivoSelected === 1 && fileUploadRegistro.current?.getFiles()?.length > 0) {
      await fileUploadRegistro.current.upload();

      const archivosActualizados = await getArchivosRegistro(values?.CodigoProveedor, Token);

      const archivosList = Array.isArray(archivosActualizados)
        ? archivosActualizados
        : [];

      setListadoArchivosRegistro(archivosList);

      archivoRegistroGuardado = archivosList?.[0] || archivoRegistroGuardado;
    }

    if (ArchivoSelected === 0 && fileUploadConstancia.current?.getFiles()?.length > 0) {
      await fileUploadConstancia.current.upload();

      const archivosActualizados = await getArchivosConstancia(values?.CodigoProveedor, Token);

      const archivosList = Array.isArray(archivosActualizados)
        ? archivosActualizados
        : [];

      setListadoArchivosConstancia(archivosList);

      archivoConstanciaGuardado = archivosList?.[0] || archivoConstanciaGuardado;
    }


    const isValid = verificarRegistroExonerado(
      archivoRegistroGuardado,
      archivoConstanciaGuardado
    );

    if (!isValid) return;

    setLoading(true);

    const datosEnviar = {
      IdRegistro: values?.IdRegistro,
      IdProveedor: idCustomer,
      Zoli: ArchivoSelected === 1,
      RegistroExonerado: values?.SinRegistroExonerado ? null : values?.RegistroExonerado,
      FechaInicio:
        ArchivoSelected === 0 && !values?.TieneConstPagosCuenta
          ? null
          : values?.SinRegistroExonerado
            ? null
            : values?.FechaInicio,

      FechaVencimiento:
        ArchivoSelected === 0 && !values?.TieneConstPagosCuenta
          ? null
          : values?.SinRegistroExonerado
            ? null
            : values?.FechaVencimiento,

      ConstPagosName: ArchivoSelected === 0 && values?.TieneConstPagosCuenta ? archivoConstanciaGuardado : null,
      NombreZona: values?.SinRegistroExonerado ? null : values?.NombreZonaLibre,
      DireccionZona: values?.SinRegistroExonerado ? null : values?.DireccionZonaLibre,
      RegistroExoneradoName: ArchivoSelected === 1 ? archivoRegistroGuardado : null,
      TieneConstPagosCuenta: ArchivoSelected === 0 ? values?.TieneConstPagosCuenta : false,
      RegistroExoneradoArchivo: null,
      SinRegistroExonerado: values?.SinRegistroExonerado,
      IdEstado: null,
    };

    const info = await saveRegistroExonerado(datosEnviar, Token);

    if (info?.[0]?.ESTADO === 1) {
      setEditable2(false);
      setBotonRegistro(false);
      toastShow(toast, 'success', 'Éxito', info[0]?.MENSAJE || 'Registro guardado correctamente.');
    } else {
      toastShow(toast, 'error', 'Error', info?.[0]?.MENSAJE || 'No se pudo guardar el registro.');
    }

    setLoading(false);
  };

  useEffect(() => {
    getInfo();
    setIdioma(lang);
    document.title = process.env.REACT_APP_SHORT_NAME +' • ' + setLabel('Titulo');


    const html = document.querySelector('html');
    html.setAttribute('lang', lang);

    const decoded = decodeToken(Token);
    if (decoded) {
      setTokenInfo(decoded);
      let { IdCustomer } = decoded;
      if (IdCustomer) {
        setIdCustomer(IdCustomer);
        getCompanyInfo({ IdCustomer });
      } else {
      }
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (validar) {
      verificarCampos();  
    }
  }, [
    validar,
    values,
    listadoArchivos,
    listadoArchivosFactura,
    listadoArchivosPermiso,
    listadoArchivosEscritura,
    listadoArchivosConstancia,
    listadoArchivosRegistro,
    ArchivoSelected
  ]);

  useEffect(() => {
    const esHonduras = values?.BancoPais?.IdCountry === IdHonduras;

    if (!esHonduras || Currencies.length === 0) return;

    const lempira = Currencies.find(
      moneda => moneda.Currency === 'Lempira'
    );

    const dolar = Currencies.find(
      moneda => moneda.Currency === 'Dollar'
    );

    setValues(prev => ({
      ...prev,
      Currency: prev.Currency || lempira || null,
      Currency2: prev.Currency2 || dolar || null,
    }));
  }, [values?.BancoPais, Currencies]);
    
  const mensajeFaltantes = (
     <div>
       <p>{setLabel('msgNoEditableIncompleta')}</p>
       <strong>{setLabel('InformacionFaltante')}:</strong>
       <div>
         <ul>
           {listaFaltantes?.map((item, index) => (
             item !== '' ? <li key={index} className="mx-4">
               <span style={{ color: 'red' }}>-</span> {item}
             </li> : null
           ))}
         </ul>
       </div>
     </div>
  );

  const footerDialog = (
    <React.Fragment>
      <Button
        label={setLabel('no')}
        icon="pi pi-times"
        onClick={() => {setShowDialogIncompleta(false)}}
      />
      <Button
        label={setLabel('guardar borrador')}
        icon="pi pi-check"
        className="p-button-success"
        onClick={() => guardarInscripcion()}
      />
    </React.Fragment>
  );

  const footerDialog2 = (
    <React.Fragment>
      <Button
        label={setLabel('Aceptar')}
        icon="pi pi-check"
        className="p-button-success"
        onClick={() => setDialogFinal(false)}
      />
    </React.Fragment>
  );

  const usuarioLogueado = !!tokenInfo?.IdUser;
  const puedeRevisar = usuarioLogueado && values?.IdStatusRevision && Number(values.IdStatusRevision) >= 68 && !tieneSolicitudEdicionAprobada;
  const puedeImprimir = Number(values?.IdStatusRevision || values?.EstadoRevision?.IdStatus || 0) >= 68 && !tieneSolicitudEdicionAprobada;

  if (tokenInfo) {
    return (
      <div id='inscripcion'>
        <Loader loading={loading} querySelector='#inscripcion' />
        <Toast position="bottom-right" ref={toast} />
        <ConfirmDialog
          visible={showDialog}
          onHide={() => setShowDialog(false)}
          header={setLabel('msgConfirmacion')}
          message={setLabel('msgNoEditable')}
          icon="pi pi-exclamation-triangle"
          rejectClassName="p-button-secondary"
          acceptClassName="p-button-success"
          accept={guardarInscripcion}
          reject={e => setShowDialog(false)}
          acceptLabel={setLabel('si')}
          rejectLabel={setLabel('no')}
        />

        {showDialogIncompleta && (
          <Dialog
            visible={showDialogIncompleta}
            onHide={() => setShowDialogIncompleta(false)}
            header={setLabel('msgConfirmacionIncompleta')}
            footer={footerDialog}
          >
            {mensajeFaltantes}
          </Dialog>
        )}

        {dialogFinal && (
          <Dialog
            visible={dialogFinal}
            onHide={() => setDialogFinal(false)}
            header={setLabel('InscripcionFinalizada')}
            footer={footerDialog2}
          >
            {setLabel('msgCompleta')}
          </Dialog>
        )}

        <div className='ProveedoreInfoContainer'>
          <div className='col-12'>
            <div className='header'>
              <div className="columna">
                <div>
                  <h1>{setLabel('Titulo')}</h1>
                  <h5>{setLabel('codigoProveedor')}: {values.CodigoProveedor}</h5>
                </div>
                {logoFormulario ? (
                  <img
                    src={logoFormulario}
                    alt="Logo Empresa"
                    className="logo"
                  />
                ) : (
                  <span style={{ fontWeight: "bold" }}>
                    {infoEmpresa?.NombreCorto || infoEmpresa?.NombreLegal || ""}
                  </span>
                )}
              </div>
              
              <div className='switchIdioma' >
                <SelectButton value={idioma} options={[{ label: 'English', value: 'en' }, { label: 'Español', value: 'es' }]} onChange={(e) => setIdioma(e.value ? e.value : 'es')} />
                <div className='mx-3'>
                  <Button  
                    text={isLightTheme}
                    icon='pi pi-sun'
                    tooltip='Light'
                    onClick={e => {
                      changeTheme('Light')
                    }}
                    severity={isLightTheme ? 'primary' : 'secondary'}
                  />
                  <Button
                    text={!isLightTheme}
                    icon='pi pi-moon'
                    tooltip='Dark'
                    onClick={e => {
                      changeTheme('Dark')
                    }}
                    severity={!isLightTheme ? 'primary' : 'secondary'}
                  />
              </div>
                </div>
            </div>

            <div className="">
              {/* INFORMACION DE LA EMPRESA */}
              <Card
                titulo={
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: isLightTheme ? "#000" : "#fff",
                    }}
                  >
                    {setLabel("informacionEmpresaTitle")}
                  </span>
                }
                contenido={(
                  <div>
                    <div className="inputsProveedorContainer" >
                      {/* Nombre Legal */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.CustomerName}
                            onChange={(e) => handleInputChange(e, 'CustomerName')}
                            className={classNames({ 'p-invalid': showMessages?.CustomerName })}
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('nombreLegal')}</label>
                        </div>
                      </div>
                      {/* Nombre Comercial (Si es distinto al nombre de la casa matriz) */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.NombreComercial}
                            onChange={(e) => handleInputChange(e, 'NombreComercial')}
                            className={classNames({ 'p-invalid': showMessages?.NombreComercial })}
                            // disabled={!editable} 
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('NombreComercial')}</label>
                        </div>
                      </div>

                      {/* Número de Identificación Tributaria RTN/RUC/UTR/BRN */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.numeroIdentificacionTributaria}
                            onChange={(e) => handleInputChange(e, 'numeroIdentificacionTributaria')}
                            className={classNames({ 'p-invalid': showMessages?.numeroIdentificacionTributaria })}
                            // disabled={!editable}
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('NumIdentificacionTributaria')}</label>
                        </div>
                        <small>RTN/RUC/UTR/BRN</small>
                      </div>

                      {/* PAIS */}
                      <div>
                        <AutoCompleteDropdown
                          name={'Country'}
                          value={values.Country}
                          label={setLabel('Pais')}
                          items={Countries}
                          field={'Country'}
                          handleInputChange={handleInputChange}
                          className={classNames({ 'p-invalid': showMessages?.Country })}
                          // enable={editable}
                          enable={isFieldEditable("InformacionEmpresa")}
                        />
                      </div>

                      {/* ESTADO*/}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.State}
                            onChange={(e) => handleInputChange(e, 'State')}
                            className={classNames({ 'p-invalid': showMessages?.State })}
                            // disabled={!editable}
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('Estado')}</label>
                        </div>
                      </div>

                      {/* CIUDAD*/}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.City}
                            onChange={(e) => handleInputChange(e, 'City')}
                            className={classNames({ 'p-invalid': showMessages?.City })}
                            // disabled={!editable}
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('Ciudad')}</label>
                        </div>
                      </div>

                      {/* Direccion Comercial */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.Address}
                            onChange={(e) => handleInputChange(e, 'Address')}
                            className={classNames({ 'p-invalid': showMessages?.Address })}
                            // disabled={!editable}
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('Direccion')}</label>
                        </div>
                      </div>

                      {/* Número de teléfono de referencia */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.Contact}
                            onChange={(e) => handleInputChange(e, 'Contact')}
                            className={classNames({ 'p-invalid': showMessages?.Contact })}
                            // disabled={!editable}
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('TelefonoRef')}</label>
                        </div>
                      </div>


                      {/* Correo electrónico */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.Email}
                            onChange={(e) => handleInputChange(e, 'Email')}
                            className={classNames({ 'p-invalid': showMessages?.Email })}
                            // disabled={!editable}
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>

                      {/* Principal actividad económica */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.PrincipalActividadEconomica}
                            onChange={(e) => handleInputChange(e, 'PrincipalActividadEconomica')}
                            className={classNames({ 'p-invalid': showMessages?.PrincipalActividadEconomica })}
                            // disabled={!editable}
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('actividadEconomica')}</label>
                        </div>
                      </div>

                      {/* Tipo de Factura */}
                      <div>
                        <AutoCompleteDropdown
                          name={'TipoFacturacion'}
                          value={values.TipoFacturacion}
                          label={setLabel('TipoFacturacion')}
                          items={tiposFactura}
                          field={idioma === 'es' ? 'tipo' : 'type'}
                          handleInputChange={handleInputChange}
                          className={classNames({ 'p-invalid': showMessages?.TipoFacturacion })}
                          // enable={editable}
                          enable={isFieldEditable("InformacionEmpresa")}
                        />
                      </div>

                      {/* Nombre de la casa matriz */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.CasaMatriz}
                            onChange={(e) => handleInputChange(e, 'CasaMatriz')}
                            className={classNames({ 'p-invalid': showMessages?.CasaMatriz })}
                            // disabled={!editable}
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('nombreCasaMatriz')}</label>
                        </div>
                        <small>{setLabel('distCasaMatriz')}</small>
                      </div>


                      {/* Dirección de la casa matriz */}
                      <div className='input-contenedor'>
                        <div className="p-float-label">
                          <InputText
                            value={values.DireccionCasaMatriz}
                            onChange={(e) => handleInputChange(e, 'DireccionCasaMatriz')}
                            className={classNames({ 'p-invalid': showMessages?.DireccionCasaMatriz })}
                            // disabled={!editable}
                            disabled={!isFieldEditable("InformacionEmpresa")}
                          />
                          <label>{setLabel('direccionCasaMatriz')}</label>
                        </div>
                        <small>{setLabel('distDireccionComercial')}</small>
                      </div>
                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.General && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                  </div>
                )}
              />

              {/* INFORMACION DE CONTACTO REPRESENTANTE LEGAL */}
              <Card
                titulo={
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: isLightTheme ? "#000" : "#fff",
                    }}
                  >
                    {setLabel("informacionContactoRepresentanteLegal")}
                  </span>
                }
                contenido={(
                  <div>
                    <div className="inputsProveedorContainer" >
                      {/* Nombre del representante legal */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.NombreRepresentanteLegal}
                            onChange={(e) => handleInputChange(e, 'NombreRepresentanteLegal')}
                            className={classNames({ 'p-invalid': showMessages?.NombreRepresentanteLegal })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>

                      {/* Correo electrónico */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.CorreoRepresentanteLegal}
                            onChange={(e) => handleInputChange(e, 'CorreoRepresentanteLegal')}
                            className={classNames({ 'p-invalid': showMessages?.CorreoRepresentanteLegal })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>

                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.RepresentanteLegal && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                  </div>
                )}
              />

              {/* INFORMACION DE CONTACTO CUENTAS POR COBRAR */}
              <Card
                titulo={
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: isLightTheme ? "#000" : "#fff",
                    }}
                  >
                    {setLabel("inforamcionContactoCuentasCobrar")}
                  </span>
                }
                contenido={(
                  <div>
                    <div className="inputsProveedorContainer" >
                      {/* Contacto de cuentas por cobrar (Nombre) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.ContactoCuentasPorCobrar}
                            onChange={(e) => handleInputChange(e, 'ContactoCuentasPorCobrar')}
                            className={classNames({ 'p-invalid': showMessages?.ContactoCuentasPorCobrar })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>

                      {/* Correo electrónico (cuentas por cobrar) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.CorreoCuentasPorCobrar}
                            onChange={(e) => handleInputChange(e, 'CorreoCuentasPorCobrar')}
                            className={classNames({ 'p-invalid': showMessages?.CorreoCuentasPorCobrar })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>

                      {/* Número de teléfono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.TelefonoCuentasPorCobrar}
                            onChange={(e) => handleInputChange(e, 'TelefonoCuentasPorCobrar')}
                            className={classNames({ 'p-invalid': showMessages?.TelefonoCuentasPorCobrar })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('numeroTelefono')}</label>
                        </div>
                      </div>
                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.CuentasPorCobrar && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                  </div>

                )} />

              {/* INFORMACION DE CONTACTO FINANZAS */}
              <Card
                titulo={
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: isLightTheme ? "#000" : "#fff",
                    }}
                  >
                    {setLabel("inforamcionContactoFinanzas")}
                  </span>
                }
                contenido={(
                  <div>
                      <div>{setLabel('Contacto')} 1</div>
                    <div className="inputsProveedorContainer" >
                      {/* Contacto de cuentas por cobrar (Nombre) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.refFin1Nombre}
                            onChange={(e) => handleInputChange(e, 'refFin1Nombre')}
                            className={classNames({ 'p-invalid': showMessages?.refFin1Nombre })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>

                      {/* Correo electrónico (cuentas por cobrar) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.refFin1Correo}
                            onChange={(e) => handleInputChange(e, 'refFin1Correo')}
                            className={classNames({ 'p-invalid': showMessages?.refFin1Correo })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>

                      {/* Número de teléfono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.refFin1Telefono}
                            onChange={(e) => handleInputChange(e, 'refFin1Telefono')}
                            className={classNames({ 'p-invalid': showMessages?.refFin1Telefono })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('numeroTelefono')}</label>
                        </div>
                      </div>
                    </div>
                    <div>{setLabel('Contacto')} 2</div>
                    <div className="inputsProveedorContainer" >
                      {/* Contacto de cuentas por cobrar (Nombre) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.refFin2Nombre}
                            onChange={(e) => handleInputChange(e, 'refFin2Nombre')}
                            className={classNames({ 'p-invalid': showMessages?.refFin2Nombre })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>

                      {/* Correo electrónico (cuentas por cobrar) */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.refFin2Correo}
                            onChange={(e) => handleInputChange(e, 'refFin2Correo')}
                            className={classNames({ 'p-invalid': showMessages?.refFin2Correo })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>

                      {/* Número de teléfono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.refFin2Telefono}
                            onChange={(e) => handleInputChange(e, 'refFin2Telefono')}
                            className={classNames({ 'p-invalid': showMessages?.refFin2Telefono })}
                            disabled={!isFieldEditable("InformacionContacto")}
                          />
                          <label>{setLabel('numeroTelefono')}</label>
                        </div>
                      </div>
                    </div>
                    {/* MENSAJES DE ERROR */}
                    {showMessages.ConcactoFinanzas && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                  </div>

                )} />

              {/* INFORMACION BANCARIA HONDURAS*/}
              {values?.BancoPais?.IdCountry === IdHonduras && (
                <Card 
                  titulo={
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: isLightTheme ? "#000" : "#fff",
                    }}
                  >
                    {setLabel("informacionBancaria")}
                  </span>
                }
                  contenido={(
                    <div>
                      <p style={{ padding: '0 15px', fontWeight: 600 }}>
                        {setLabel("mensajeConstanciaBancaria")}
                      </p>

                      <div className="pb-4 pt-4" style={{ width: '20%', padding: '0 15px' }}>
                        <AutoCompleteDropdown
                          name={'BancoPais'}
                          value={values.BancoPais}
                          label={setLabel("bancoPais")}
                          items={Countries}
                          field={'Country'}
                          handleInputChange={handleInputChange}
                          className={classNames({ 'p-invalid': showMessages?.BancoPais })}
                          enable={isFieldEditable("InformacionBancaria")}
                        />
                      </div>

                      <p style={{ padding: '0 15px', fontWeight: 600 }}>
                        {setLabel("actualiceDatosBancarios")}
                      </p>

                      <p style={{ padding: '0 15px', fontWeight: 600 }}>
                        {setLabel("pagosCuentasRegistradas")}
                      </p>

                      <p style={{ padding: '0 25px', fontWeight: 600 }}>
                        {setLabel("empresasSociedadesCuenta")}
                      </p>

                      <p style={{ padding: '0 25px', fontWeight: 600 }}>
                        {setLabel("personasNaturalesCuenta")}
                      </p>

                      <p style={{ padding: '0 15px', fontWeight: 400 }}>
                        {setLabel("actualizacionObligatoriaLavado")}
                      </p>

                      {/* Cuenta Bancaria Lempiras */}
                      <p
                        style={{
                          padding: '0 15px',
                          marginTop: 10,
                          marginBottom: -10,
                          fontWeight: 600,
                          fontSize: 16,
                        }}
                      >
                        {setLabel('cuentaBancariaLempiras')}
                      </p>
                      <div className="inputsProveedorContainer">
                        <div className="input-contenedor">
                          <div className="p-float-label">
                            <InputText
                              value={values?.NumeroCuentaBancaria}
                              onChange={(e) => handleInputChange(e, 'NumeroCuentaBancaria')}
                              className={classNames({ 'p-invalid': showMessages?.NumeroCuentaBancaria })}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('numeroCuenta')}</label>
                          </div>
                        </div>

                        <div className="input-contenedor">
                          <div className="p-float-label">
                            <InputText
                              value={values?.TitularCuenta}
                              onChange={(e) => handleInputChange(e, 'TitularCuenta')}
                              className={classNames({ 'p-invalid': showMessages?.TitularCuenta })}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('titularCuenta')}</label>
                          </div>
                        </div>

                        <div>
                          <AutoCompleteDropdown
                            name={'Banco'}
                            value={values?.Banco}
                            label={setLabel('Banco')}
                            items={Bancos}
                            field={'NombreBanco'}
                            handleInputChange={handleInputChange}
                            className={classNames({ 'p-invalid': showMessages?.BancoCampo })}
                            enable={isFieldEditable("InformacionBancaria")}
                          />
                        </div>

                        <div>
                          <AutoCompleteDropdown
                            name={'TipoCuenta'}
                            value={values?.TipoCuenta}
                            label={setLabel('tipoCuenta')}
                            items={tiposCuentas}
                            field={'tipo'}
                            handleInputChange={handleInputChange}
                            className={classNames({ 'p-invalid': showMessages?.TipoCuenta })}
                            enable={isFieldEditable("InformacionBancaria")}
                          />
                        </div>

                        <div>
                          <AutoCompleteDropdown
                            name={'Currency'}
                            value={values?.Currency}
                            label={setLabel('Moneda')}
                            items={Currencies}
                            field={'Currency'}
                            handleInputChange={handleInputChange}
                            className={classNames({ 'p-invalid': showMessages?.Currency })}
                            enable={isFieldEditable("InformacionBancaria")}
                          />
                        </div>
                      </div>

                      {/* Cuenta Bancaria Dolar */}
                      <p
                        style={{
                          padding: '0 15px',
                          marginTop: 10,
                          marginBottom: -10,
                          fontWeight: 600,
                          fontSize: 16,
                        }}
                      >
                        {setLabel('cuentaBancariaDolares')}
                      </p>
                      <div className="inputsProveedorContainer">
                        <div className="input-contenedor">
                          <div className="p-float-label">
                            <InputText
                              value={values?.NumeroCuentaBancaria2}
                              onChange={(e) => handleInputChange(e, 'NumeroCuentaBancaria2')}
                              className={classNames({
                                'p-invalid': showMessages?.NumeroCuentaBancaria2
                              })}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('numeroCuenta')}</label>
                          </div>
                        </div>

                        <div className="input-contenedor">
                          <div className="p-float-label">
                            <InputText
                              value={values?.TitularCuenta2}
                              onChange={(e) => handleInputChange(e, 'TitularCuenta2')}
                              className={classNames({
                                'p-invalid': showMessages?.TitularCuenta2
                              })}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('titularCuenta')}</label>
                          </div>
                        </div>

                        <div>
                          <AutoCompleteDropdown
                            name={'Banco2'}
                            value={values?.Banco2}
                            label={setLabel('Banco')}
                            items={Bancos}
                            field={'NombreBanco'}
                            handleInputChange={handleInputChange}
                            className={classNames({
                              'p-invalid': showMessages?.Banco2
                            })}
                            enable={isFieldEditable("InformacionBancaria")}
                          />
                        </div>

                        <div>
                          <AutoCompleteDropdown
                            name={'TipoCuenta2'}
                            value={values?.TipoCuenta2}
                            label={setLabel('tipoCuenta')}
                            items={tiposCuentas}
                            field={'tipo'}
                            handleInputChange={handleInputChange}
                            className={classNames({
                              'p-invalid': showMessages?.TipoCuenta2
                            })}
                            enable={isFieldEditable("InformacionBancaria")}
                          />
                        </div>

                        <div>
                          <AutoCompleteDropdown
                            name={'Currency2'}
                            value={values?.Currency2}
                            label={setLabel('Moneda')}
                            items={Currencies}
                            field={'Currency'}
                            handleInputChange={handleInputChange}
                            className={classNames({
                              'p-invalid': showMessages?.Currency2
                            })}
                            enable={isFieldEditable("InformacionBancaria")}
                          />
                        </div>
                      </div>

                      {values?.Banco && ![2, 19].includes(values.Banco.IdBanco) && (
                        <>
                          <p style={{ padding: '0 15px', fontWeight: 600 }}>
                            {setLabel("elijaComoRecibirPagos")}
                            <span style={{ fontWeight: 400 }}>{setLabel("siCuentaNoBanco")}</span>
                          </p>

                          <p style={{ padding: '0 15px', fontWeight: 600 }}>
                            {setLabel("atencion")}
                            <span style={{ fontWeight: 400 }}>{setLabel("politicasFinancieras")}</span>
                          </p>

                         <p style={{ padding: '0 15px', fontWeight: 600 }}>
                            {setLabel("dosOpcionesRecibirDinero")}
                          </p>

                          <p style={{ padding: '0 15px', fontWeight: 600 }}>
                            {setLabel("opcion1")}
                            <span style={{ fontWeight: 400 }}>{setLabel("opcion1Transferencia")}</span>
                          </p>

                          <div className="d-flex align-items-center mb-3" style={{ marginLeft: 10, fontWeight: 600 }}>
                            <Checkbox
                              inputId="DeduccionACH"
                              name="FormaPagoBanco"
                              checked={values?.selectedOption === "DeduccionACH"}
                              onChange={() => handleFormaPagoBanco("DeduccionACH")}
                              disabled={!isFieldEditable("InformacionBancaria")}
                              className={classNames({ "p-invalid": showMessages?.selectedOption })}
                            />
                            <span className="mx-3">
                              {setLabel("aceptoDeduccionComision")}
                            </span>                         
                          </div>

                          <p style={{ padding: '0 15px', fontWeight: 600 }}>
                            {setLabel("opcion2")}
                            <span style={{ fontWeight: 400 }}>{setLabel("opcion2Cheque")}</span>
                          </p>

                          <div className="d-flex align-items-center mb-3" style={{ marginLeft: 10, fontWeight: 600 }}>
                            <Checkbox
                              inputId="PagarCheque"
                              name="FormaPagoBanco"
                              checked={values?.selectedOption === "PagarCheque"}
                              onChange={() => handleFormaPagoBanco("PagarCheque")}
                              disabled={!isFieldEditable("InformacionBancaria")}
                              className={classNames({ "p-invalid": showMessages?.selectedOption })}
                            />
                            <span className="mx-3">{setLabel("aceptoPagoCheque")}</span>
                          </div>

                          {values?.selectedOption === 'PagarCheque' && (
                            <div>
                              <p style={{ padding: '0 15px', fontWeight: 600 }}>{setLabel("compromisos")}</p>
                              <p style={{ padding: '0 15px', fontWeight: 400, marginLeft: 5 }}>{setLabel("compromisoCheque1")}</p>
                              <p style={{ padding: '0 15px', fontWeight: 400, marginLeft: 5 }}>{setLabel("compromisoCheque2")}</p>
                            </div>
                          )}

                          {showMessages.selectedOption && (
                            <div className="p-error">{setLabel("debeSeleccionarOpcionPago")}</div>
                          )}
                        </>
                      )}

                      <p style={{ padding: '0 15px', fontWeight: 600, fontSize: 11.5 }}>
                        {setLabel("confirmacionCuentaBancaria")}
                        <span style={{ fontStyle: 'italic', fontWeight: 600 }}>
                          {setLabel("confirmacionCuentaBancariaTexto")}
                        </span>
                      </p>

                      {showMessages.Banco && (
                        <div className="p-error">{setLabel('completarCamposObligatorios')}</div>
                      )}
                    </div>
                  )}
                />
              )}

              {/* INFORMACION BANCARIA INTERNACIONAL */}
              {values?.BancoPais?.IdCountry !== IdHonduras && (
                <Card
                  titulo={
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: isLightTheme ? "#000" : "#fff",
                    }}
                  >
                    {setLabel("informacionBancaria")}
                  </span>
                }
                  contenido={(
                    <div>
                      <p style={{ padding: '0 15px', fontWeight: 600 }}>
                        {setLabel("mensajeConstanciaBancaria")}
                      </p>

                      <div className="pb-4 pt-4" style={{ width: '20%', padding: '0 15px' }}>
                        <AutoCompleteDropdown
                          name={'BancoPais'}
                          value={values.BancoPais}
                          label={setLabel("bancoPais")}
                          items={Countries}
                          field={'Country'}
                          handleInputChange={handleInputChange}
                          className={classNames({ 'p-invalid': showMessages?.BancoPais })}
                          enable={isFieldEditable("InformacionBancaria")}
                        />
                      </div>

                      <p style={{ padding: '0 15px', fontWeight: 600 }}>
                        {setLabel("completeDatosBancariosInternacionales")}
                      </p>

                      <p style={{ padding: '0 15px', fontWeight: 600 }}>
                        {setLabel("importantePagosInternacionales")}
                        <span style={{ fontStyle: 'italic', fontWeight: 600 }}>
                          {' '}{setLabel("pagosInternacionalesTexto")}
                        </span>
                      </p>

                      <p style={{ padding: '0 15px', fontWeight: 600, marginLeft: 5 }}>
                       {setLabel("empresasSociedadesMercantiles")} {setLabel("cuentaNombreEmpresa")}
                      </p>

                      <p style={{ padding: '0 15px', fontWeight: 600, marginLeft: 5 }}>
                        {setLabel("personasNaturalesInternacional")}{setLabel("cuentaNombrePersonal")}
                      </p>

                      <div className="inputsProveedorContainer">
                        <div>
                          <AutoCompleteDropdown
                            name={'Currency'}
                            value={values?.Currency}
                            label={setLabel('Moneda')}
                            items={Currencies}
                            field={'Currency'}
                            handleInputChange={handleInputChange}
                            className={classNames({ 'p-invalid': showMessages?.Currency })}
                            enable={isFieldEditable("InformacionBancaria")}
                          />
                        </div>
                      </div>

                      <div>
                        <span style={{ fontWeight: 800, marginLeft: 10 }}>{setLabel('bancoIntermediario')}:</span>
                      </div>

                      <div className="inputsProveedorContainer">
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoIntermediarioNombre}
                              onChange={(e) => handleInputChange(e, 'BancoIntermediarioNombre')}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('Banco')}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoIntermediarioDireccion}
                              onChange={(e) => handleInputChange(e, 'BancoIntermediarioDireccion')}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('Direccion')}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoIntermediarioSwift}
                              onChange={(e) => handleInputChange(e, 'BancoIntermediarioSwift')}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('Swift')}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoIntermediarioAbaBin}
                              onChange={(e) => handleInputChange(e, 'BancoIntermediarioAbaBin')}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>ABA / BIN</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoIntermediarioCuenta}
                              onChange={(e) => handleInputChange(e, 'BancoIntermediarioCuenta')}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('numeroCuenta')}</label>
                          </div>
                        </div>
                      </div>

                      <div>
                        <span style={{ fontWeight: 800, marginLeft: 10 }}>{setLabel('bancoBeneficiario')}:</span>
                      </div>

                      <div className="inputsProveedorContainer">
                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoBeneficiarioNombre}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioNombre')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioNombre })}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('Banco')}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoBeneficiarioDireccion}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioDireccion')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioDireccion })}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('Direccion')}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoBeneficiarioSwift}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioSwift')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioSwift })}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('Swift')}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoBeneficiarioNombreBeneficiario}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioNombreBeneficiario')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioNombreBeneficiario })}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('nombreBeneficiario')}</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoBeneficiarioAbaBin}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioAbaBin')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioAbaBin })}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>ABA / BIN</label>
                          </div>
                        </div>

                        <div>
                          <div className="p-float-label">
                            <InputText
                              value={values?.BancoBeneficiarioCuenta}
                              onChange={(e) => handleInputChange(e, 'BancoBeneficiarioCuenta')}
                              className={classNames({ 'p-invalid': showMessages?.BancoBeneficiarioCuenta })}
                              disabled={!isFieldEditable("InformacionBancaria")}
                            />
                            <label>{setLabel('numeroCuenta')}</label>
                          </div>
                        </div>
                      </div>

                      <p style={{ padding: '0 15px', fontWeight: 600, fontSize: 11.5, marginTop: 15 }}>
                        {setLabel("confirmacionBancoInternacional")}
                        <span style={{ fontStyle: 'italic', fontWeight: 600 }}>
                          {setLabel("confirmacionBancoInternacionalTexto")}
                        </span>
                      </p>

                      {showMessages.Banco && (
                        <div className="p-error">{setLabel('completarCamposObligatorios')}</div>
                      )}
                    </div>
                  )}
                />
              )}

              {/* REFERENCIAS COMERCIALES */}
              <Card
                titulo={
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: isLightTheme ? "#000" : "#fff",
                    }}
                  >
                    {setLabel("referenciasComerciales")}
                  </span>
                }
                contenido={(
                  <div className="">

                    {/* NOMBRE COMPAñIA 1 */}
                    <div className='seccionText'>
                      <span>{setLabel('Referencia')} 1:</span>
                    </div>

                    <div className='inputsProveedorContainer'>
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.ref1Nombre}
                            onChange={(e) => handleInputChange(e, 'ref1Nombre')}
                            className={classNames({ 'p-invalid': showMessages?.ref1Nombre })}
                            disabled={!isFieldEditable("InformacionComercial")}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>
                      {/* Telefono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.ref1Telefono}
                            onChange={(e) => handleInputChange(e, 'ref1Telefono')}
                            className={classNames({ 'p-invalid': showMessages?.ref1Telefono })}
                            disabled={!isFieldEditable("InformacionComercial")}
                          />
                          <label>{setLabel('numeroTelefono')}</label>
                        </div>
                      </div>
                      {/* Correo */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.ref1Correo}
                            onChange={(e) => handleInputChange(e, 'ref1Correo')}
                            className={classNames({ 'p-invalid': showMessages?.ref1Correo })}
                            disabled={!isFieldEditable("InformacionComercial")}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>
                    </div>

                    {/* NOMBRE COMPAñIA 2 */}
                    <div className='seccionText'>
                      <span>{setLabel('Referencia')} 2:</span>
                    </div>

                    <div className='inputsProveedorContainer'>
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.ref2Nombre}
                            onChange={(e) => handleInputChange(e, 'ref2Nombre')}
                            className={classNames({ 'p-invalid': showMessages?.ref2Nombre })}
                            disabled={!isFieldEditable("InformacionComercial")}
                          />
                          <label>{setLabel('Nombre')}</label>
                        </div>
                      </div>
                      {/* Telefono */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.ref2Telefono}
                            onChange={(e) => handleInputChange(e, 'ref2Telefono')}
                            className={classNames({ 'p-invalid': showMessages?.ref2Telefono })}
                            disabled={!isFieldEditable("InformacionComercial")}
                          />
                          <label>{setLabel('numeroTelefono')}</label>
                        </div>
                      </div>
                      {/* Correo */}
                      <div>
                        <div className="p-float-label">
                          <InputText
                            value={values.ref2Correo}
                            onChange={(e) => handleInputChange(e, 'ref2Correo')}
                            className={classNames({ 'p-invalid': showMessages?.ref2Correo })}
                            disabled={!isFieldEditable("InformacionComercial")}
                          />
                          <label>{setLabel('Email')}</label>
                        </div>
                      </div>
                    </div>

                    {/* MENSAJES DE ERROR */}
                    {showMessages.ReferenciasComerciales && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}
                  </div>

                )}
              />

              {/* INFORMACION FINANCIERA */}
              <Card
                titulo={
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: isLightTheme ? "#000" : "#fff",
                    }}
                  >
                    {setLabel("informacionFinanciera")}
                  </span>
                }
                contenido={(
                  <div>
                    <div style={{ width: 200 }}>
                      <AutoCompleteDropdown
                        name={'CurrencyFin'}
                        value={values?.CurrencyFin}
                        label={setLabel("currency")}
                        items={Currencies}
                        field={'Currency'}
                        handleInputChange={handleInputChange}
                        className={classNames({ 'p-invalid': showMessages?.CurrencyFin })}
                        enable={isFieldEditable("InformacionFinanciera")}
                      />
                    </div>

                    <div className='seccionText'>
                     <span style={{ fontSize: 14, fontWeight: "bold", color: "#000" }}>
                        {setLabel("activos")}
                      </span>
                    </div>

                    <div className='inputsProveedorContainer'>
                      <div>
                        <div className="p-float-label">
                          <InputNumber
                            value={values?.ActivosCorrientes}
                            onChange={(e) => handleInputChange(e, 'ActivosCorrientes')}
                            className={classNames({ 'p-invalid': showMessages?.ActivosCorrientes })}
                            maxFractionDigits={2}
                            disabled={!isFieldEditable("InformacionFinanciera")}
                          />
                          <label>{setLabel("activosCorrientes")}</label>
                        </div>
                      </div>

                      <div>
                        <div className="p-float-label">
                          <InputNumber
                            value={values?.TotalActivos}
                            onChange={(e) => handleInputChange(e, 'TotalActivos')}
                            className={classNames({ 'p-invalid': showMessages?.TotalActivos })}
                            maxFractionDigits={2}
                            disabled={!isFieldEditable("InformacionFinanciera")}
                          />
                          <label>{setLabel("totalActivos")}</label>
                        </div>
                      </div>
                    </div>

                    <div className='seccionText'>
                      <span style={{ fontSize: 14, fontWeight: "bold", color: "#000" }}>
                        {setLabel("pasivos")}
                      </span>
                    </div>

                    <div className='inputsProveedorContainer'>
                      <div>
                        <div className="p-float-label">
                          <InputNumber
                            value={values?.PasivosCorrientes}
                            onChange={(e) => handleInputChange(e, 'PasivosCorrientes')}
                            className={classNames({ 'p-invalid': showMessages?.PasivosCorrientes })}
                            maxFractionDigits={2}
                            disabled={!isFieldEditable("InformacionFinanciera")}
                          />
                          <label>{setLabel("pasivosCorrientes")}</label>
                        </div>
                      </div>

                      <div>
                        <div className="p-float-label">
                          <InputNumber
                            value={values?.TotalPasivos}
                            onChange={(e) => handleInputChange(e, 'TotalPasivos')}
                            className={classNames({ 'p-invalid': showMessages?.TotalPasivos })}
                            maxFractionDigits={2}
                            disabled={!isFieldEditable("InformacionFinanciera")}
                          />
                          <label>{setLabel("totalPasivos")}</label>
                        </div>
                      </div>
                    </div>

                    {showMessages.Financiera && (
                      <div className="p-error">{setLabel('completarCamposObligatorios')}</div>
                    )}
                  </div>
                )}
              />  

              {/* DOCUMENTACION */}
              <Card
                titulo={
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: "bold",
                      color: isLightTheme ? "#000" : "#fff",
                    }}
                  >
                    {setLabel("documentacion")}
                  </span>
                }
                contenido={(
                  <div  >

                    <div className='seccionText'>
                      <span>{setLabel('adjuntarDocumentos')}</span>
                    </div>
                    
                    <div className="">
                      {/* RTN */}
                      <div>
                        <div>
                          {/* {(ArchivoBIC?.name ? ArchivoBIC.name : '')} */}
                          <label for="formFile" className="form-label"><strong>BIC:</strong> RTN/NIT/RUC/TAX ID</label>
                          <div className="mb-3">
                            <FileUpload
                              ref={fileUploadBIC}
                              name="demo"
                              url="./upload"
                              customUpload
                              uploadHandler={subirFileBIC}
                              required
                              headerTemplate={headerUploadTemplate}
                              maxFileSize={5242880}
                              disabled={!isFieldEditable("Documentacion")}
                              chooseLabel={setLabel('subirBIC')}
                            />
                            {showMessages?.BICName && <small className="p-error">Por favor, seleccione un archivo BIC.</small>}
                            <div className="mt-3">
                            <div>
                              {listadoArchivos?.map((a, i) => (
                                <div
                                  className="d-flex gap p-2 border mt-2"
                                  style={{ alignItems: "center" }}
                                  key={i}
                                >
                                  <div className="col-9">{a}</div>
                                  <Button
                                    icon="pi pi-download"
                                    onClick={() => getArchivo(a)}
                                  />
                                  <Button
                                    icon="pi pi-trash"
                                    severity="danger"
                                    onClick={() => eliminar(a)}
                                    disabled={!isFieldEditable("Documentacion")}
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                          </div>
                        </div>
                      </div>

                      {/* FACTURA */}
                      <div className="mb-3">
                        <label for="formFile" className="form-label"><strong>{setLabel('Factura')}:</strong></label>
                          <FileUpload
                            ref={fileUploadFactura}
                            name="demo"
                            url="./upload"
                            multiple
                            customUpload
                            uploadHandler={subirFileFactura}
                            required
                            headerTemplate={headerUploadTemplate}
                            maxFileSize={5242880}
                            disabled={!isFieldEditable("Documentacion")}
                            chooseLabel={setLabel('subirFactura')}
                          />
                        {showMessages?.FacturaName && <small className="p-error">Por favor, agregue una Factura.</small>}

                        <div>
                          {listadoArchivosFactura?.map((a, i) => (
                            <div
                              className="d-flex gap p-2 border mt-2"
                              style={{ alignItems: "center" }}
                              key={i}
                            >
                              <div className="col-9">{a}</div>
                              <Button
                                icon="pi pi-download"
                                onClick={() => getArchivoFactura(a)}
                              />
                              <Button
                                icon="pi pi-trash"
                                severity="danger"
                                onClick={() => eliminarFactura(a)}
                                disabled={!isFieldEditable("Documentacion")}
                              />
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* PERMISO DE OPERACIONES */}
                      {values?.Country?.IdCountry === IdHonduras && <div>
                        <div>
                          <div className="mb-3">
                            <label for="formFile" className="form-label"><strong>{setLabel('PermisoOperaciones')}:</strong></label>
                            <FileUpload
                              ref={fileUploadPermiso}
                              name="demo"
                              url="./upload"
                              multiple
                              customUpload
                              uploadHandler={subirFilePermiso}
                              className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.resultArchivoPermisoOperaciones })}
                              headerTemplate={headerUploadTemplate}
                              maxFileSize={5242880}
                              disabled={!isFieldEditable("Documentacion")}
                              chooseLabel={setLabel('subirPermiso')}
                            />
                            {showMessages?.PermisoOperacionesName && <small className="p-error">Por favor, agregue un Permiso de Operaciones.</small>}
                            <div>
                            {listadoArchivosPermiso?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => getArchivoPermiso(a)}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => eliminarPermiso(a)}
                                  disabled={!isFieldEditable("Documentacion")}
                                />
                              </div>
                            ))}
                          </div>

                          </div>
                        </div>
                      </div>}

                      {/* Escritura Constitucion */}
                      {values?.Country?.IdCountry === IdHonduras && <div>
                        <div>
                          <div className="mb-3">
                            <label for="formFile" className="form-label"><strong>{setLabel('escrituraConstitucion')}:</strong></label>
                            <FileUpload
                              ref={fileUploadEscritura}
                              name="demo"
                              url="./upload"
                              multiple
                              customUpload
                              uploadHandler={subirFileEscritura}
                              className={classNames('form-control p-inputtext p-component', { 'p-invalid': showMessages?.EscrituraConstitucionName })}
                              required
                              headerTemplate={headerUploadTemplate}
                              maxFileSize={5242880}
                              disabled={!isFieldEditable("Documentacion")}
                              chooseLabel={setLabel('subirEscritura')}
                            />
                            {showMessages?.EscrituraConstitucionName && <small className="p-error">Por favor, agregue la Escritura de Constitucion.</small>}
                            
                            {listadoArchivosEscritura?.map((a, i) => (
                              <div
                                className="d-flex gap p-2 border mt-2"
                                style={{ alignItems: "center" }}
                                key={i}
                              >
                                <div className="col-9">{a}</div>
                                <Button
                                  icon="pi pi-download"
                                  onClick={() => getArchivoEscritura(a)}
                                />
                                <Button
                                  icon="pi pi-trash"
                                  severity="danger"
                                  onClick={() => eliminarEscritura(a)}
                                  disabled={!isFieldEditable("Documentacion")}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>}


                      {values?.Country?.IdCountry === IdHonduras && <div>

                        {/* ARCHIVO NACIONAL */}
                        <div>
                          {/* SITUACIÓN FISCAL */}
                          <div
                            ref={fileUpload}
                            style={{
                              border: "2px solid #222",
                              borderRadius: "6px",
                              padding: "12px",
                              marginTop: "15px",
                            }}
                          >
                            <p style={{ fontWeight: 800, fontSize: 12 }}>
                              {setLabel("declaracionSituacionFiscalTitulo")}
                              <span style={{ fontStyle: "italic", marginLeft: 4 }}>
                                {setLabel("declaracionSituacionFiscalTexto")}
                              </span>
                            </p>

                            <p style={{ paddingLeft: 15, fontWeight: 600 }}>• {setLabel("registroExoneradosSefin")}</p>
                            <p style={{ paddingLeft: 15, fontWeight: 600 }}>• {setLabel("constanciaPagosCuentaSar")}</p>
                            <p style={{ fontWeight: 600 }}>{setLabel("aplicaremosRetenciones")}</p>

                            <div
                              className="d-flex align-items-center"
                              style={{
                                borderTop: "1px solid #ddd",
                                borderBottom: "1px solid #ddd",
                                padding: "14px 10px",
                                gap: 12,
                              }}
                            >
                              <strong>{setLabel("operoZonaLibre")}</strong>

                              <span>{setLabel("no")}</span>

                              <InputSwitch
                                checked={ArchivoSelected === 1}
                                onChange={() => {
                                  const nuevoValor = ArchivoSelected === 1 ? 0 : 1;

                                  setArchivoSelected(nuevoValor);
                                  setBotonRegistro(true);

                                  setListadoArchivosRegistro([]);
                                  setListadoArchivosConstancia([]);

                                  fileUploadRegistro.current?.clear?.();
                                  fileUploadConstancia.current?.clear?.();

                                  setValues(prev => ({
                                    ...prev,
                                    IdRegistro: null,
                                    SinRegistroExonerado: false,
                                    TieneConstPagosCuenta: nuevoValor === 0 ? true : false,
                                    RegistroExonerado: "",
                                    FechaInicio: null,
                                    FechaVencimiento: null,
                                    NombreZonaLibre: "",
                                    DireccionZonaLibre: "",
                                    RegistroExoneradoName: null,
                                    ConstPagosName: null,
                                  }));
                                }}
                                disabled={!editable2}
                              />

                              <span>{setLabel("si")}</span>

                              <Button
                                label={setLabel("actualizarInformacion")}
                                icon="pi pi-refresh"
                                className="p-button-secondary"
                                style={{ height: 40, minWidth: 190 }}
                                onClick={ArchivoSelected === 1 ? limpiarZonaLibre : limpiarConstanciaPagos}
                              />

                              {botonRegistro && (
                                <Button
                                  label={setLabel("guardarRegistro")}
                                  icon="pi pi-save"
                                  className="p-button-secondary"
                                  style={{ height: 40 }}
                                  onClick={addRegistro}
                                />
                              )}
                            </div>

                            {/* SI NO ES ZONA LIBRE: CONSTANCIA DE PAGOS */}
                            {ArchivoSelected === 0 && (
                              <div style={{ paddingTop: 12 }}>
                                <div style={{ borderBottom: "1px solid #ddd", paddingBottom: 10 }}>
                                  <Checkbox
                                    checked={values?.TieneConstPagosCuenta}
                                    onChange={(e) => {
                                      setValues(prev => ({
                                        ...prev,
                                        TieneConstPagosCuenta: e.checked,
                                        FechaInicio: e.checked ? prev.FechaInicio : null,
                                        FechaVencimiento: e.checked ? prev.FechaVencimiento : null,
                                        ConstPagosName: e.checked ? prev.ConstPagosName : null,
                                      }));
                                    }}
                                    className={classNames("mx-2", { "p-invalid": showMessages?.TieneConstPagosCuenta })}
                                    disabled={!editable2}
                                  />
                                  <strong>{setLabel("cuentoConstanciaPagosCuenta")}</strong>
                                </div>

                                {values?.TieneConstPagosCuenta ? (
                                  <>
                                    <div className="d-flex gap mt-3" style={{ flexWrap: "wrap" }}>
                                      <div className="p-float-label" style={{ width: 250 }}>
                                        <Calendar
                                          value={values.FechaInicio}
                                          onChange={(e) => setValues(prev => ({ ...prev, FechaInicio: e.value }))}
                                          dateFormat="yy-mm-dd"
                                          className={classNames({ "p-invalid": showMessages?.FechaInicio })}
                                          style={{ height: 40, width: "100%" }}
                                          disabled={!editable2}
                                          showIcon
                                        />
                                        <label>{setLabel("fechaInicio")}</label>
                                      </div>

                                      <div className="p-float-label" style={{ width: 250 }}>
                                        <Calendar
                                          value={values.FechaVencimiento}
                                          onChange={(e) => setValues(prev => ({ ...prev, FechaVencimiento: e.value }))}
                                          dateFormat="yy-mm-dd"
                                          className={classNames({ "p-invalid": showMessages?.FechaVencimiento })}
                                          style={{ height: 40, width: "100%" }}
                                          disabled={!editable2}
                                          showIcon
                                        />
                                        <label>{setLabel("fechaVencimiento")}</label>
                                      </div>
                                    </div>

                                    <label className="form-label mt-2">
                                      <strong>{setLabel("constPagosCuenta")}:</strong>
                                    </label>

                                    {values.ConstPagosName && !listadoArchivosConstancia?.includes(values.ConstPagosName) && (
                                      <div
                                        className="d-flex gap p-2 border mt-2"
                                        style={{ alignItems: "center" }}
                                      >
                                        <div className="col-9">{values.ConstPagosName}</div>
                                        <Button icon="pi pi-download" onClick={() => getArchivoConstancia(values.ConstPagosName)} />
                                        <Button
                                          icon="pi pi-trash"
                                          severity="danger"
                                          onClick={() => eliminarConstancia(values.ConstPagosName)}
                                          disabled={!editable2}
                                        />
                                      </div>
                                    )}

                                    {/* CONSTANCIA */}
                                    <div className="p-3 border mt-2">
                                      <FileUpload
                                        ref={fileUploadConstancia}
                                        name="demo"
                                        url="./upload"
                                        multiple
                                        customUpload
                                        uploadHandler={subirFileConstancia}
                                        headerTemplate={headerUploadTemplate}
                                        maxFileSize={5242880}
                                        disabled={!editable2}
                                        chooseLabel={setLabel("subirConstPagos")}
                                      />
                                      {listadoArchivosConstancia?.map((a, i) => (
                                        <div
                                          className="d-flex gap p-2 border mt-2"
                                          style={{ alignItems: "center" }}
                                          key={i}
                                        >
                                          <div className="col-9">{a}</div>

                                          <Button
                                            icon="pi pi-download"
                                            onClick={() => getArchivoConstancia(a)}
                                          />

                                          <Button
                                            icon="pi pi-trash"
                                            severity="danger"
                                            onClick={() => eliminarConstancia(a)}
                                            disabled={!editable2}
                                          />
                                        </div>
                                      ))}
                                    
                                    </div>
                                  </>
                                ) : (
                                  <p style={{ textAlign: "center", fontWeight: 600, padding: 15 }}>
                                    {setLabel("mensajeRetencionesFiscales")}
                                  </p>
                                )}
                              </div>
                            )}

                            {/* SI ES ZONA LIBRE: REGISTRO EXONERADO */}
                            {ArchivoSelected === 1 && (
                              <div style={{ paddingTop: 12 }}>
                                <div style={{ borderBottom: "1px solid #ddd", paddingBottom: 10 }}>
                                  <Checkbox
                                    checked={values?.SinRegistroExonerado}
                                    onChange={(e) => {
                                      const checked = e.checked;

                                      setValues(prev => ({
                                        ...prev,
                                        SinRegistroExonerado: checked,
                                        ...(checked && {
                                          RegistroExonerado: "",
                                          FechaInicio: null,
                                          FechaVencimiento: null,
                                          NombreZonaLibre: "",
                                          DireccionZonaLibre: "",
                                          RegistroExoneradoName: null,
                                        }),
                                      }));
                                    }}
                                    className={classNames("mx-2", { "p-invalid": showMessages?.SinRegistroExonerado })}
                                    disabled={!editable2}
                                  />
                                  <strong>{setLabel("noCuentoRegistroExonerado")}</strong>
                                </div>

                                {values?.SinRegistroExonerado ? (
                                  <p style={{ textAlign: "center", fontWeight: 600, padding: 15 }}>
                                    {setLabel("noCuentaRegistroExoneradoVigente")}
                                  </p>
                                ) : (
                                  <>
                                    <div className="inputsProveedorContainer mt-3">
                                      <div className="input-contenedor">
                                        <div className="p-float-label">
                                          <InputText
                                            value={values?.RegistroExonerado}
                                            onChange={(e) => handleInputChange(e, "RegistroExonerado")}
                                            className={classNames({ "p-invalid": showMessages?.RegistroExonerado })}
                                            readOnly={!editable2}
                                          />
                                          <label>{setLabel("numeroRegistroExonerado")}</label>
                                        </div>
                                      </div>

                                      <div className="input-contenedor">
                                        <div className="p-float-label">
                                          <Calendar
                                            value={values.FechaInicio}
                                            onChange={(e) => setValues(prev => ({ ...prev, FechaInicio: e.value }))}
                                            dateFormat="yy-mm-dd"
                                            className={classNames({ "p-invalid": showMessages?.FechaInicio })}
                                            style={{ height: 40, width: "100%" }}
                                            disabled={!editable2}
                                            showIcon
                                          />
                                          <label>{setLabel("fechaInicio")}</label>
                                        </div>
                                      </div>

                                      <div className="input-contenedor">
                                        <div className="p-float-label">
                                          <Calendar
                                            value={values.FechaVencimiento}
                                            onChange={(e) => setValues(prev => ({ ...prev, FechaVencimiento: e.value }))}
                                            dateFormat="yy-mm-dd"
                                            className={classNames({ "p-invalid": showMessages?.FechaVencimiento })}
                                            style={{ height: 40, width: "100%" }}
                                            disabled={!editable2}
                                            showIcon
                                          />
                                          <label>{setLabel("fechaVencimiento")}</label>
                                        </div>
                                      </div>

                                      <div className="input-contenedor">
                                        <div className="p-float-label">
                                          <InputText
                                            value={values?.NombreZonaLibre}
                                            onChange={(e) => handleInputChange(e, "NombreZonaLibre")}
                                            className={classNames({ "p-invalid": showMessages?.NombreZonaLibre })}
                                            readOnly={!editable2}
                                          />
                                          <label>{setLabel("nombreZona")}</label>
                                        </div>
                                      </div>

                                      <div className="input-contenedor">
                                        <div className="p-float-label">
                                          <InputText
                                            value={values?.DireccionZonaLibre}
                                            onChange={(e) => handleInputChange(e, "DireccionZonaLibre")}
                                            className={classNames({ "p-invalid": showMessages?.DireccionZonaLibre })}
                                            readOnly={!editable2}
                                          />
                                          <label>{setLabel("direccionZona")}</label>
                                        </div>
                                      </div>
                                    </div>

                                    <label className="form-label mt-2">
                                      <strong>{setLabel("registroExonerado")}:</strong>
                                    </label>   

                                    {values.RegistroExoneradoName && !listadoArchivosRegistro?.includes(values.RegistroExoneradoName) && (
                                      <div
                                        className="d-flex gap p-2 border mt-2"
                                        style={{ alignItems: "center" }}
                                      >
                                        <div className="col-9">{values.RegistroExoneradoName}</div>
                                        <Button icon="pi pi-download" onClick={() => getArchivoRegistro(values.RegistroExoneradoName)} />
                                        <Button
                                          icon="pi pi-trash"
                                          severity="danger"
                                          onClick={() => eliminarRegistro(values.RegistroExoneradoName)}
                                          disabled={!editable2}
                                        />
                                      </div>
                                    )}

                                    <div className="p-3 border mt-2">
                                      <FileUpload
                                        ref={fileUploadRegistro}
                                        name="demo"
                                        url="./upload"
                                        multiple
                                        customUpload
                                        uploadHandler={subirFileRegistro}
                                        headerTemplate={headerUploadTemplate}
                                        maxFileSize={5242880}
                                        disabled={!editable2}
                                        chooseLabel={setLabel("subirRegistroExonerado")}
                                      />

                                      {listadoArchivosRegistro?.map((a, i) => (
                                        <div
                                          className="d-flex gap p-2 border mt-2"
                                          style={{ alignItems: "center" }}
                                          key={i}
                                        >
                                          <div className="col-9">{a}</div>
                                          <Button icon="pi pi-download" onClick={() => getArchivoRegistro(a)} />
                                          <Button
                                            icon="pi pi-trash"
                                            severity="danger"
                                            onClick={() => eliminarRegistro(a)}
                                            disabled={!editable2}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                      </div>}

                    </div>
                  </div>
                )} />

            </div>

            {/* AUTORIZACION */}
            <div className='m-4'>
              <div>
                <div className='d-flex align-items-center mb-3'>
                  <Checkbox
                    required={true}
                    checked={values.AutorizacionDeposito}
                    onChange={(e) => handleInputChange(e, 'AutorizacionDeposito')}
                    className={classNames('mx-3', { 'p-invalid': showMessages?.AutorizacionDeposito })}
                    disabled={!editable}
                  />
                  <span>
                    {setLabel('autorizacionPagos', {
                      nombreEmpresa: infoEmpresa?.NombreLegal || "",
                      nombreCorto: infoEmpresa?.NombreCorto || "",
                    })}
                  </span>
                </div>
                {/* MENSAJES DE ERROR */}
                {showMessages.AutorizacionDeposito && <div className="p-error">{setLabel('completarCamposObligatorios')}</div>}

              </div>
              <br />

              <div style={{ marginLeft: 52 }}>
                <span>{setLabel('infCierta')}</span>
              </div>

            </div>

            {/* FOOTER DEL FORMATO (BTN DE GUARDAR,LIMPIAR,IMPRIMIR,REVISAR) */}
            <div className="footerContainer"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  marginTop: 20,
                  gap: 15,
                }}
              >
              <div className="botonesContainer">
                {/* BTN GUARDAR BORRADO */}
                <Button
                  className="m-2 p-button-success"
                  label={incompleta ? setLabel('guardar borrador') : setLabel('guardar')}
                  icon="pi pi-save"
                  onClick={() => {
                    setValidar(true);

                    const validacion = verificarCampos();

                    if (validacion.listaFaltantes.length > 0) {
                      setShowDialogIncompleta(true);
                    } else {
                      setShowDialog(true);
                    }
                  }}
                  // disabled={!editable}
                  disabled={!(editable || tieneSolicitudEdicionAprobada)}
                />

                {/* BTN LIMPIAR */}
                <Button
                  className="m-2 p-button-danger"
                  label="Limpiar"
                  icon="pi pi-trash"
                  onClick={() => setValues(initialValues)}
                  disabled={!editable}
                />

                {puedeImprimir && (
                  <Button
                    className="m-2"
                    label={setLabel("imprimir")}
                    icon="pi pi-print"
                    onClick={() => setShowDialogFormato(true)}
                  />
                )}

                {puedeRevisar && (
                  <Button
                    className="m-2 p-button-success"
                    label="Revisar"
                    icon="pi pi-check"
                    onClick={() => setShowDialogEstadoRevision(true)}
                  />
                )}
              </div>

              {!editable && (
                <div style={{ width: 400, marginLeft: 10 }}>
                  <strong>{setLabel('agregarFormatoInscripcion')}</strong>

                  <FileUpload
                    ref={fileUploadFormato}
                    name="demo"
                    url="./upload"
                    multiple
                    customUpload
                    uploadHandler={subirFileFormato}
                    required
                    maxFileSize={5242880}
                    chooseLabel="Seleccionar archivo"
                    uploadLabel="Guardar formato"
                    showCancelButton={false}
                  />

                  {listadoArchivosFormato?.map((a, i) => (
                    <div
                      className="d-flex gap p-2 border mt-2"
                      style={{ alignItems: "center" }}
                      key={i}
                    >
                      <div className="col-9">{a}</div>
                      <Button icon="pi pi-download" onClick={() => getArchivoFormato(a)} />
                      <Button icon="pi pi-trash" severity="danger" onClick={() => eliminarFormato(a)} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {showDialogFormato && (
          <FormatoInscripcionPDF
            setShowDialogFormato={setShowDialogFormato}
            showDialogFormato={showDialogFormato}
            Numero={idCustomer}
            Idioma={idioma}
            Token={Token}
          />
        )}

        {showDialogEstadoRevision && (
          <DialogEstadoRevision
            visible={showDialogEstadoRevision}
            setVisible={setShowDialogEstadoRevision}
            informacion={values}
            tokenInfo={tokenInfo}
            Token={Token}
            getCompanyInfo={getCompanyInfo}
          />
        )}
      </div >
    );
  } else {
    return (
      <div>
        <h1>{setLabel('noPermiso')}</h1>
      </div>
    )
  }
};

export default InscripcionProveedores;
